window.overviewAnimation2 = {
    "nm": "Comp 1",
    "ddd": 0,
    "h": 732,
    "w": 764,
    "meta": {
        "g": "@lottiefiles/toolkit-js 0.76.0"
    },
    "layers": [
        {
            "ty": 0,
            "nm": "animation",
            "sr": 1,
            "st": -57,
            "op": 4782,
            "ip": 0,
            "ln": "32309",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "1",
            "ind": 1
        }
    ],
    "v": "5.7.0",
    "fr": 60,
    "op": 452,
    "ip": 0,
    "fonts": {
        "list": [
            {
                "ascent": null,
                "fClass": "",
                "fFamily": "BDO Grotesk",
                "fStyle": "Medium",
                "fName": "BDOGrotesk-Medium",
                "fPath": "",
                "fWeight": "",
                "origin": 0
            }
        ]
    },
    "chars": [
        {
            "ch": "Y",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 65.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                38.8,
                                                0
                                            ],
                                            [
                                                27,
                                                0
                                            ],
                                            [
                                                27,
                                                -30.7
                                            ],
                                            [
                                                -0.6,
                                                -72.9
                                            ],
                                            [
                                                13.5,
                                                -72.9
                                            ],
                                            [
                                                33,
                                                -41.4
                                            ],
                                            [
                                                52.7,
                                                -72.9
                                            ],
                                            [
                                                66.4,
                                                -72.9
                                            ],
                                            [
                                                38.8,
                                                -30.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "o",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.099999999999999,
                                                2.466666666666667
                                            ],
                                            [
                                                2.266666666666666,
                                                4.333333333333333
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ],
                                            [
                                                -2.2666666666666666,
                                                4.400000000000001
                                            ],
                                            [
                                                -4.133333333333333,
                                                2.433333333333337
                                            ],
                                            [
                                                -5.466666666666666,
                                                0
                                            ],
                                            [
                                                -4.099999999999999,
                                                -2.4333333333333322
                                            ],
                                            [
                                                -2.2333333333333343,
                                                -4.399999999999996
                                            ],
                                            [
                                                0,
                                                -5.866666666666667
                                            ],
                                            [
                                                2.2333333333333343,
                                                -4.366666666666666
                                            ],
                                            [
                                                4.099999999999999,
                                                -2.433333333333333
                                            ],
                                            [
                                                5.533333333333334,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.533333333333334,
                                                0
                                            ],
                                            [
                                                -4.100000000000001,
                                                -2.466666666666667
                                            ],
                                            [
                                                -2.2666666666666666,
                                                -4.333333333333332
                                            ],
                                            [
                                                0,
                                                -5.9333333333333345
                                            ],
                                            [
                                                2.266666666666666,
                                                -4.399999999999996
                                            ],
                                            [
                                                4.1333333333333355,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.533333333333334,
                                                0
                                            ],
                                            [
                                                4.099999999999999,
                                                2.433333333333337
                                            ],
                                            [
                                                2.2333333333333343,
                                                4.400000000000001
                                            ],
                                            [
                                                0,
                                                5.9333333333333345
                                            ],
                                            [
                                                -2.2333333333333343,
                                                4.366666666666666
                                            ],
                                            [
                                                -4.099999999999999,
                                                2.433333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.3,
                                                1
                                            ],
                                            [
                                                16.85,
                                                -2.7
                                            ],
                                            [
                                                7.3,
                                                -12.9
                                            ],
                                            [
                                                3.9,
                                                -28.2
                                            ],
                                            [
                                                7.3,
                                                -43.7
                                            ],
                                            [
                                                16.9,
                                                -53.95
                                            ],
                                            [
                                                31.3,
                                                -57.6
                                            ],
                                            [
                                                45.75,
                                                -53.95
                                            ],
                                            [
                                                55.25,
                                                -43.7
                                            ],
                                            [
                                                58.6,
                                                -28.3
                                            ],
                                            [
                                                55.25,
                                                -12.85
                                            ],
                                            [
                                                45.75,
                                                -2.65
                                            ],
                                            [
                                                31.3,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.7333333333333294,
                                                3.4333333333333322
                                            ],
                                            [
                                                0,
                                                6.199999999999998
                                            ],
                                            [
                                                2.7333333333333343,
                                                3.366666666666665
                                            ],
                                            [
                                                4.9333333333333345,
                                                0
                                            ],
                                            [
                                                2.7666666666666657,
                                                -3.4666666666666637
                                            ],
                                            [
                                                0,
                                                -6.0666666666666655
                                            ],
                                            [
                                                -2.733333333333333,
                                                -3.4
                                            ],
                                            [
                                                -5,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4.9333333333333345,
                                                0
                                            ],
                                            [
                                                2.7333333333333343,
                                                -3.433333333333335
                                            ],
                                            [
                                                0,
                                                -6.200000000000003
                                            ],
                                            [
                                                -2.7333333333333294,
                                                -3.366666666666665
                                            ],
                                            [
                                                -4.9333333333333345,
                                                0
                                            ],
                                            [
                                                -2.766666666666667,
                                                3.4666666666666686
                                            ],
                                            [
                                                0,
                                                6.2
                                            ],
                                            [
                                                2.7333333333333343,
                                                3.4
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.3,
                                                -8.8
                                            ],
                                            [
                                                42.8,
                                                -13.95
                                            ],
                                            [
                                                46.9,
                                                -28.4
                                            ],
                                            [
                                                42.8,
                                                -42.75
                                            ],
                                            [
                                                31.3,
                                                -47.8
                                            ],
                                            [
                                                19.75,
                                                -42.6
                                            ],
                                            [
                                                15.6,
                                                -28.3
                                            ],
                                            [
                                                19.7,
                                                -13.9
                                            ],
                                            [
                                                31.3,
                                                -8.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "u",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.433333333333335,
                                                3.5
                                            ],
                                            [
                                                0,
                                                6
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2,
                                                -1.8000000000000007
                                            ],
                                            [
                                                -3.3333333333333335,
                                                0
                                            ],
                                            [
                                                -2.066666666666663,
                                                1.1000000000000003
                                            ],
                                            [
                                                -1.1666666666666667,
                                                1.9666666666666675
                                            ],
                                            [
                                                -0.06666666666666761,
                                                2.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.0333333333333363,
                                                -1.6333333333333335
                                            ],
                                            [
                                                3.6000000000000014,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.399999999999999,
                                                0
                                            ],
                                            [
                                                -3.433333333333333,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.3999999999999986
                                            ],
                                            [
                                                2,
                                                1.7999999999999996
                                            ],
                                            [
                                                2.800000000000002,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                -1.099999999999999
                                            ],
                                            [
                                                1.1666666666666667,
                                                -1.9666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7999999999999972,
                                                2.9333333333333336
                                            ],
                                            [
                                                -3.0333333333333314,
                                                1.6333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                26.7,
                                                1
                                            ],
                                            [
                                                11.95,
                                                -4.25
                                            ],
                                            [
                                                6.8,
                                                -18.5
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                18.5,
                                                -56.6
                                            ],
                                            [
                                                18.5,
                                                -19.9
                                            ],
                                            [
                                                21.5,
                                                -12.1
                                            ],
                                            [
                                                29.5,
                                                -9.4
                                            ],
                                            [
                                                36.8,
                                                -11.05
                                            ],
                                            [
                                                41.65,
                                                -15.65
                                            ],
                                            [
                                                43.5,
                                                -22.6
                                            ],
                                            [
                                                43.5,
                                                -56.6
                                            ],
                                            [
                                                55.2,
                                                -56.6
                                            ],
                                            [
                                                55.2,
                                                0
                                            ],
                                            [
                                                44.4,
                                                0
                                            ],
                                            [
                                                43.9,
                                                -8.3
                                            ],
                                            [
                                                36.65,
                                                -1.45
                                            ],
                                            [
                                                26.7,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "\xe2\x80\x99",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 22.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333329,
                                                0.8666666666666648
                                            ],
                                            [
                                                0,
                                                1.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8333333333333346,
                                                -1.5666666666666629
                                            ],
                                            [
                                                3.133333333333333,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666671,
                                                0
                                            ],
                                            [
                                                0.6333333333333329,
                                                -0.8666666666666648
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.2666666666666706
                                            ],
                                            [
                                                -1.8333333333333333,
                                                1.5666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                6.9,
                                                -47.1
                                            ],
                                            [
                                                4.6,
                                                -47.1
                                            ],
                                            [
                                                4.6,
                                                -53.2
                                            ],
                                            [
                                                6.5,
                                                -53.2
                                            ],
                                            [
                                                10.25,
                                                -54.5
                                            ],
                                            [
                                                11.2,
                                                -57.8
                                            ],
                                            [
                                                11.2,
                                                -61.5
                                            ],
                                            [
                                                5.5,
                                                -61.5
                                            ],
                                            [
                                                5.5,
                                                -73.8
                                            ],
                                            [
                                                17.1,
                                                -73.8
                                            ],
                                            [
                                                17.1,
                                                -56.7
                                            ],
                                            [
                                                14.35,
                                                -49.45
                                            ],
                                            [
                                                6.9,
                                                -47.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "r",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 36.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.2999999999999994,
                                                1.5666666666666675
                                            ],
                                            [
                                                -3,
                                                0
                                            ],
                                            [
                                                -1.1333333333333304,
                                                -0.3999999999999962
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7333333333333295,
                                                0.09999999999999905
                                            ],
                                            [
                                                0.7333333333333343,
                                                0
                                            ],
                                            [
                                                2.2666666666666657,
                                                -2.1666666666666665
                                            ],
                                            [
                                                0.40000000000000097,
                                                -3.7333333333333294
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4666666666666661,
                                                -3
                                            ],
                                            [
                                                2.300000000000002,
                                                -1.5666666666666629
                                            ],
                                            [
                                                2,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333362,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -0.09999999999999905
                                            ],
                                            [
                                                -3.7333333333333343,
                                                0
                                            ],
                                            [
                                                -2.2666666666666657,
                                                2.1666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                17.3,
                                                -56.6
                                            ],
                                            [
                                                18,
                                                -48.1
                                            ],
                                            [
                                                23.65,
                                                -54.95
                                            ],
                                            [
                                                31.6,
                                                -57.3
                                            ],
                                            [
                                                36.3,
                                                -56.7
                                            ],
                                            [
                                                36.3,
                                                -45.7
                                            ],
                                            [
                                                35.6,
                                                -45.7
                                            ],
                                            [
                                                33.7,
                                                -46.15
                                            ],
                                            [
                                                31.5,
                                                -46.3
                                            ],
                                            [
                                                22.5,
                                                -43.05
                                            ],
                                            [
                                                18.5,
                                                -34.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "e",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 59.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.133333333333333,
                                                2.3000000000000003
                                            ],
                                            [
                                                2.3000000000000007,
                                                4.366666666666666
                                            ],
                                            [
                                                0,
                                                6.133333333333333
                                            ],
                                            [
                                                -2.166666666666667,
                                                4.400000000000001
                                            ],
                                            [
                                                -4.033333333333332,
                                                2.433333333333337
                                            ],
                                            [
                                                -5.666666666666667,
                                                0
                                            ],
                                            [
                                                -4,
                                                -2.400000000000001
                                            ],
                                            [
                                                -2.0333333333333314,
                                                -4.799999999999997
                                            ],
                                            [
                                                0.5333333333333314,
                                                -7.133333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                3.433333333333337
                                            ],
                                            [
                                                4.999999999999997,
                                                0
                                            ],
                                            [
                                                2.866666666666667,
                                                -3.200000000000003
                                            ],
                                            [
                                                0,
                                                -7
                                            ],
                                            [
                                                -2.8000000000000007,
                                                -3.2666666666666657
                                            ],
                                            [
                                                -5.133333333333333,
                                                0
                                            ],
                                            [
                                                -2.4666666666666686,
                                                1.7666666666666668
                                            ],
                                            [
                                                -0.6000000000000038,
                                                3.2000000000000006
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.2333333333333343,
                                                -2.5333333333333337
                                            ],
                                            [
                                                3.400000000000001,
                                                -1.4333333333333333
                                            ],
                                            [
                                                4.400000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.466666666666666,
                                                0
                                            ],
                                            [
                                                -4.133333333333333,
                                                -2.3000000000000003
                                            ],
                                            [
                                                -2.3,
                                                -4.366666666666667
                                            ],
                                            [
                                                0,
                                                -5.9333333333333345
                                            ],
                                            [
                                                2.1666666666666665,
                                                -4.399999999999996
                                            ],
                                            [
                                                4.033333333333334,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.466666666666669,
                                                0
                                            ],
                                            [
                                                4,
                                                2.400000000000001
                                            ],
                                            [
                                                2.0333333333333314,
                                                4.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.8666666666666695,
                                                -5.666666666666664
                                            ],
                                            [
                                                -2.433333333333337,
                                                -3.4333333333333322
                                            ],
                                            [
                                                -4.533333333333334,
                                                0
                                            ],
                                            [
                                                -2.866666666666666,
                                                3.199999999999998
                                            ],
                                            [
                                                0,
                                                6.866666666666667
                                            ],
                                            [
                                                2.7999999999999994,
                                                3.266666666666667
                                            ],
                                            [
                                                3.9333333333333322,
                                                0
                                            ],
                                            [
                                                2.4666666666666637,
                                                -1.7666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                3.4
                                            ],
                                            [
                                                -2.2333333333333294,
                                                2.533333333333333
                                            ],
                                            [
                                                -3.400000000000001,
                                                1.4333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.4,
                                                1
                                            ],
                                            [
                                                17,
                                                -2.45
                                            ],
                                            [
                                                7.35,
                                                -12.45
                                            ],
                                            [
                                                3.9,
                                                -28.2
                                            ],
                                            [
                                                7.15,
                                                -43.7
                                            ],
                                            [
                                                16.45,
                                                -53.95
                                            ],
                                            [
                                                31,
                                                -57.6
                                            ],
                                            [
                                                45.2,
                                                -54
                                            ],
                                            [
                                                54.25,
                                                -43.2
                                            ],
                                            [
                                                56.5,
                                                -25.3
                                            ],
                                            [
                                                13.8,
                                                -25.3
                                            ],
                                            [
                                                13.8,
                                                -33.7
                                            ],
                                            [
                                                49,
                                                -33.7
                                            ],
                                            [
                                                44.3,
                                                -29.8
                                            ],
                                            [
                                                41.95,
                                                -43.45
                                            ],
                                            [
                                                30.8,
                                                -48.6
                                            ],
                                            [
                                                19.7,
                                                -43.8
                                            ],
                                            [
                                                15.4,
                                                -28.5
                                            ],
                                            [
                                                19.6,
                                                -13.3
                                            ],
                                            [
                                                31.5,
                                                -8.4
                                            ],
                                            [
                                                41.1,
                                                -11.05
                                            ],
                                            [
                                                45.7,
                                                -18.5
                                            ],
                                            [
                                                55.9,
                                                -16
                                            ],
                                            [
                                                51.55,
                                                -7.1
                                            ],
                                            [
                                                43.1,
                                                -1.15
                                            ],
                                            [
                                                31.4,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": " ",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 23,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": []
                    }
                ]
            }
        },
        {
            "ch": "n",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.9666666666666663,
                                                1.5
                                            ],
                                            [
                                                -3.866666666666665,
                                                0
                                            ],
                                            [
                                                -3.599999999999999,
                                                -3.2666666666666657
                                            ],
                                            [
                                                0,
                                                -6.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.900000000000001,
                                                1.9333333333333325
                                            ],
                                            [
                                                3.799999999999997,
                                                0
                                            ],
                                            [
                                                2.1666666666666665,
                                                -1.099999999999999
                                            ],
                                            [
                                                1.2666666666666657,
                                                -2.0666666666666678
                                            ],
                                            [
                                                0.06666666666666761,
                                                -2.799999999999997
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -3.200000000000003
                                            ],
                                            [
                                                2.9666666666666663,
                                                -1.5
                                            ],
                                            [
                                                5.733333333333334,
                                                0
                                            ],
                                            [
                                                3.6000000000000036,
                                                3.2666666666666706
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.3333333333333335
                                            ],
                                            [
                                                -1.900000000000001,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2.5333333333333363,
                                                0
                                            ],
                                            [
                                                -2.1666666666666665,
                                                1.099999999999999
                                            ],
                                            [
                                                -1.2666666666666657,
                                                2.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                17.5,
                                                -56.6
                                            ],
                                            [
                                                18.1,
                                                -48.3
                                            ],
                                            [
                                                26.05,
                                                -55.35
                                            ],
                                            [
                                                36.3,
                                                -57.6
                                            ],
                                            [
                                                50.3,
                                                -52.7
                                            ],
                                            [
                                                55.7,
                                                -37.9
                                            ],
                                            [
                                                55.7,
                                                0
                                            ],
                                            [
                                                44.1,
                                                0
                                            ],
                                            [
                                                44.1,
                                                -36.5
                                            ],
                                            [
                                                41.25,
                                                -44.4
                                            ],
                                            [
                                                32.7,
                                                -47.3
                                            ],
                                            [
                                                25.65,
                                                -45.65
                                            ],
                                            [
                                                20.5,
                                                -40.9
                                            ],
                                            [
                                                18.5,
                                                -33.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "t",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 33,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.0333333333333337,
                                                1.7666666666666666
                                            ],
                                            [
                                                0,
                                                3.4
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6000000000000014,
                                                -0.6999999999999993
                                            ],
                                            [
                                                -1.8666666666666671,
                                                0
                                            ],
                                            [
                                                -0.7666666666666657,
                                                0.10000000000000024
                                            ],
                                            [
                                                -0.5333333333333314,
                                                0.13333333333333286
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4666666666666661,
                                                -0.16666666666666666
                                            ],
                                            [
                                                1.2666666666666682,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -3.9999999999999987,
                                                0
                                            ],
                                            [
                                                -2.0333333333333328,
                                                -1.7666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2.0666666666666664
                                            ],
                                            [
                                                0.5999999999999991,
                                                0.7000000000000005
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                0.766666666666668,
                                                -0.10000000000000024
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.4666666666666661,
                                                0.3333333333333333
                                            ],
                                            [
                                                -1.4666666666666661,
                                                0.16666666666666663
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.9,
                                                0.7
                                            ],
                                            [
                                                12.85,
                                                -1.95
                                            ],
                                            [
                                                9.8,
                                                -9.7
                                            ],
                                            [
                                                9.8,
                                                -72.1
                                            ],
                                            [
                                                21.2,
                                                -73.1
                                            ],
                                            [
                                                21.2,
                                                -14.2
                                            ],
                                            [
                                                22.1,
                                                -10.05
                                            ],
                                            [
                                                25.8,
                                                -9
                                            ],
                                            [
                                                28.45,
                                                -9.15
                                            ],
                                            [
                                                30.4,
                                                -9.5
                                            ],
                                            [
                                                30.4,
                                                -0.3
                                            ],
                                            [
                                                26,
                                                0.45
                                            ],
                                            [
                                                21.9,
                                                0.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                15.5,
                                                -47.9
                                            ],
                                            [
                                                2.3,
                                                -47.8
                                            ],
                                            [
                                                2.3,
                                                -56.6
                                            ],
                                            [
                                                15.5,
                                                -56.5
                                            ],
                                            [
                                                15.5,
                                                -47.9
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.4,
                                                -56.6
                                            ],
                                            [
                                                30.4,
                                                -47.8
                                            ],
                                            [
                                                15.5,
                                                -47.9
                                            ],
                                            [
                                                15.5,
                                                -56.5
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "h",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.900000000000001,
                                                1.400000000000001
                                            ],
                                            [
                                                -3.799999999999997,
                                                0
                                            ],
                                            [
                                                -3.599999999999999,
                                                -3.2666666666666657
                                            ],
                                            [
                                                0,
                                                -6.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.900000000000001,
                                                1.9333333333333325
                                            ],
                                            [
                                                3.799999999999997,
                                                0
                                            ],
                                            [
                                                2.1666666666666665,
                                                -1.099999999999999
                                            ],
                                            [
                                                1.2666666666666657,
                                                -2.0666666666666678
                                            ],
                                            [
                                                0.06666666666666761,
                                                -2.866666666666665
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.2666666666666657,
                                                -3.0666666666666678
                                            ],
                                            [
                                                2.900000000000001,
                                                -1.3999999999999961
                                            ],
                                            [
                                                5.733333333333334,
                                                0
                                            ],
                                            [
                                                3.6000000000000036,
                                                3.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.3333333333333335
                                            ],
                                            [
                                                -1.900000000000001,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2.5333333333333363,
                                                0
                                            ],
                                            [
                                                -2.1666666666666665,
                                                1.099999999999999
                                            ],
                                            [
                                                -1.2666666666666657,
                                                2.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -79
                                            ],
                                            [
                                                18.5,
                                                -79
                                            ],
                                            [
                                                18.5,
                                                -49
                                            ],
                                            [
                                                26.25,
                                                -55.7
                                            ],
                                            [
                                                36.3,
                                                -57.8
                                            ],
                                            [
                                                50.3,
                                                -52.9
                                            ],
                                            [
                                                55.7,
                                                -38.1
                                            ],
                                            [
                                                55.7,
                                                0
                                            ],
                                            [
                                                44.1,
                                                0
                                            ],
                                            [
                                                44.1,
                                                -36.7
                                            ],
                                            [
                                                41.25,
                                                -44.6
                                            ],
                                            [
                                                32.7,
                                                -47.5
                                            ],
                                            [
                                                25.65,
                                                -45.85
                                            ],
                                            [
                                                20.5,
                                                -41.1
                                            ],
                                            [
                                                18.5,
                                                -33.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "P",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 70.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.7666666666666657,
                                                -1.8333333333333333
                                            ],
                                            [
                                                -2,
                                                -3.3666666666666694
                                            ],
                                            [
                                                0,
                                                -4.533333333333331
                                            ],
                                            [
                                                2.0333333333333363,
                                                -3.3333333333333335
                                            ],
                                            [
                                                3.799999999999997,
                                                -1.8333333333333333
                                            ],
                                            [
                                                5.333333333333333,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                1.9666666666666686
                                            ],
                                            [
                                                0,
                                                4.066666666666667
                                            ],
                                            [
                                                2.300000000000002,
                                                2
                                            ],
                                            [
                                                3.800000000000002,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.333333333333333,
                                                0
                                            ],
                                            [
                                                3.7666666666666657,
                                                1.8333333333333333
                                            ],
                                            [
                                                2.000000000000005,
                                                3.3666666666666694
                                            ],
                                            [
                                                0,
                                                4.599999999999999
                                            ],
                                            [
                                                -2.0333333333333363,
                                                3.3333333333333335
                                            ],
                                            [
                                                -3.800000000000002,
                                                1.8333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.7333333333333343,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -1.966666666666664
                                            ],
                                            [
                                                0,
                                                -4
                                            ],
                                            [
                                                -2.299999999999997,
                                                -2
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                20.1,
                                                0
                                            ],
                                            [
                                                8.2,
                                                0
                                            ],
                                            [
                                                8.2,
                                                -72.9
                                            ],
                                            [
                                                41.6,
                                                -72.9
                                            ],
                                            [
                                                55.25,
                                                -70.15
                                            ],
                                            [
                                                63.9,
                                                -62.35
                                            ],
                                            [
                                                66.9,
                                                -50.5
                                            ],
                                            [
                                                63.85,
                                                -38.6
                                            ],
                                            [
                                                55.1,
                                                -30.85
                                            ],
                                            [
                                                41.4,
                                                -28.1
                                            ],
                                            [
                                                18.5,
                                                -28.1
                                            ],
                                            [
                                                18.5,
                                                -38.4
                                            ],
                                            [
                                                42,
                                                -38.4
                                            ],
                                            [
                                                51.1,
                                                -41.35
                                            ],
                                            [
                                                54.6,
                                                -50.4
                                            ],
                                            [
                                                51.15,
                                                -59.4
                                            ],
                                            [
                                                42,
                                                -62.4
                                            ],
                                            [
                                                20.1,
                                                -62.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "l",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 25.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.4,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -79
                                            ],
                                            [
                                                18.4,
                                                -79
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "a",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 58.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.266666666666667,
                                                2.9333333333333336
                                            ],
                                            [
                                                0,
                                                4.733333333333333
                                            ],
                                            [
                                                -1.6333333333333335,
                                                2.366666666666667
                                            ],
                                            [
                                                -2.6999999999999993,
                                                1.3333333333333333
                                            ],
                                            [
                                                -3.2666666666666657,
                                                0.5999999999999991
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.9000000000000009,
                                                1.033333333333336
                                            ],
                                            [
                                                0,
                                                1.7333333333333343
                                            ],
                                            [
                                                1.599999999999999,
                                                1.4333333333333325
                                            ],
                                            [
                                                4.066666666666667,
                                                0
                                            ],
                                            [
                                                2.366666666666665,
                                                -1.6000000000000039
                                            ],
                                            [
                                                -0.06666666666666525,
                                                -3.400000000000001
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.3999999999999995,
                                                3.0333333333333314
                                            ],
                                            [
                                                -7.133333333333333,
                                                0
                                            ],
                                            [
                                                -3.300000000000002,
                                                -1.3000000000000018
                                            ],
                                            [
                                                -1.7000000000000028,
                                                -2.5666666666666678
                                            ],
                                            [
                                                0,
                                                -3.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -0.5666666666666664
                                            ],
                                            [
                                                -0.8666666666666648,
                                                0
                                            ],
                                            [
                                                -0.2666666666666657,
                                                0.033333333333333805
                                            ],
                                            [
                                                -0.06666666666666761,
                                                0.06666666666666643
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2000000000000028,
                                                -0.1666666666666667
                                            ],
                                            [
                                                0.6666666666666666,
                                                0
                                            ],
                                            [
                                                1.8333333333333333,
                                                1.4000000000000001
                                            ],
                                            [
                                                0.13333333333333522,
                                                2.7999999999999994
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.5666666666666678,
                                                -1.8666666666666665
                                            ],
                                            [
                                                4.466666666666666,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.933333333333333,
                                                0
                                            ],
                                            [
                                                -3.266666666666667,
                                                -2.9333333333333336
                                            ],
                                            [
                                                0,
                                                -3.6
                                            ],
                                            [
                                                1.6333333333333335,
                                                -2.366666666666665
                                            ],
                                            [
                                                2.7000000000000006,
                                                -1.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.800000000000002,
                                                -0.5333333333333314
                                            ],
                                            [
                                                0.8999999999999962,
                                                -1.0333333333333314
                                            ],
                                            [
                                                0,
                                                -2.2666666666666657
                                            ],
                                            [
                                                -1.599999999999999,
                                                -1.4333333333333371
                                            ],
                                            [
                                                -4,
                                                0
                                            ],
                                            [
                                                -2.366666666666667,
                                                1.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.06666666666666643,
                                                -5.666666666666667
                                            ],
                                            [
                                                4.400000000000001,
                                                -3.0333333333333363
                                            ],
                                            [
                                                4.933333333333333,
                                                0
                                            ],
                                            [
                                                3.299999999999997,
                                                1.2999999999999972
                                            ],
                                            [
                                                1.6999999999999982,
                                                2.5666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                1.9333333333333336
                                            ],
                                            [
                                                0.7333333333333343,
                                                0.5666666666666677
                                            ],
                                            [
                                                0.5333333333333362,
                                                0
                                            ],
                                            [
                                                0.2666666666666657,
                                                -0.033333333333333805
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                0.3333333333333333
                                            ],
                                            [
                                                -1.1999999999999982,
                                                0.16666666666666666
                                            ],
                                            [
                                                -3,
                                                0
                                            ],
                                            [
                                                -1.8333333333333333,
                                                -1.3999999999999997
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.466666666666664,
                                                3.0666666666666664
                                            ],
                                            [
                                                -3.5666666666666678,
                                                1.8666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                22.7,
                                                1
                                            ],
                                            [
                                                8.9,
                                                -3.4
                                            ],
                                            [
                                                4,
                                                -14.9
                                            ],
                                            [
                                                6.45,
                                                -23.85
                                            ],
                                            [
                                                12.95,
                                                -29.4
                                            ],
                                            [
                                                21.9,
                                                -32.3
                                            ],
                                            [
                                                33.9,
                                                -34.5
                                            ],
                                            [
                                                39.45,
                                                -36.85
                                            ],
                                            [
                                                40.8,
                                                -41
                                            ],
                                            [
                                                38.4,
                                                -46.55
                                            ],
                                            [
                                                29.9,
                                                -48.7
                                            ],
                                            [
                                                20.35,
                                                -46.3
                                            ],
                                            [
                                                16.9,
                                                -38.8
                                            ],
                                            [
                                                6,
                                                -40
                                            ],
                                            [
                                                12.7,
                                                -53.05
                                            ],
                                            [
                                                30,
                                                -57.6
                                            ],
                                            [
                                                42.35,
                                                -55.65
                                            ],
                                            [
                                                49.85,
                                                -49.85
                                            ],
                                            [
                                                52.4,
                                                -40.3
                                            ],
                                            [
                                                52.4,
                                                -12.8
                                            ],
                                            [
                                                53.5,
                                                -9.05
                                            ],
                                            [
                                                55.9,
                                                -8.2
                                            ],
                                            [
                                                57.1,
                                                -8.25
                                            ],
                                            [
                                                57.6,
                                                -8.4
                                            ],
                                            [
                                                58.2,
                                                -8.4
                                            ],
                                            [
                                                58.2,
                                                -0.2
                                            ],
                                            [
                                                55.3,
                                                0.55
                                            ],
                                            [
                                                52.5,
                                                0.8
                                            ],
                                            [
                                                45.25,
                                                -1.3
                                            ],
                                            [
                                                42.3,
                                                -7.6
                                            ],
                                            [
                                                42.3,
                                                -9.2
                                            ],
                                            [
                                                34.75,
                                                -1.8
                                            ],
                                            [
                                                22.7,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.699999999999998,
                                                1.6666666666666667
                                            ],
                                            [
                                                -0.8666666666666648,
                                                2.9333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                -0.3999999999999986
                                            ],
                                            [
                                                2.3333333333333335,
                                                -0.4666666666666662
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2666666666666657,
                                                -1.5666666666666675
                                            ],
                                            [
                                                0,
                                                -1.8666666666666671
                                            ],
                                            [
                                                -1.866666666666666,
                                                -1.2666666666666668
                                            ],
                                            [
                                                -2.866666666666667,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.866666666666667,
                                                0
                                            ],
                                            [
                                                2.700000000000003,
                                                -1.6666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.7333333333333343,
                                                0.6000000000000014
                                            ],
                                            [
                                                -1.3333333333333333,
                                                0.40000000000000097
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.7999999999999994,
                                                0.733333333333332
                                            ],
                                            [
                                                -1.2666666666666668,
                                                1.5666666666666653
                                            ],
                                            [
                                                0,
                                                2.6666666666666665
                                            ],
                                            [
                                                1.8666666666666671,
                                                1.2666666666666668
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                25.8,
                                                -8
                                            ],
                                            [
                                                35.65,
                                                -10.5
                                            ],
                                            [
                                                41,
                                                -17.4
                                            ],
                                            [
                                                41,
                                                -29.2
                                            ],
                                            [
                                                42.1,
                                                -28.8
                                            ],
                                            [
                                                39,
                                                -27.3
                                            ],
                                            [
                                                33.5,
                                                -26
                                            ],
                                            [
                                                25.4,
                                                -24.4
                                            ],
                                            [
                                                17.8,
                                                -20.95
                                            ],
                                            [
                                                15.9,
                                                -15.8
                                            ],
                                            [
                                                18.7,
                                                -9.9
                                            ],
                                            [
                                                25.8,
                                                -8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "\xe2\x80\x94",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 87.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                80.6,
                                                -27.2
                                            ],
                                            [
                                                6.9,
                                                -27.2
                                            ],
                                            [
                                                6.9,
                                                -37.6
                                            ],
                                            [
                                                80.6,
                                                -37.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "$",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 63.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                36.2,
                                                11.8
                                            ],
                                            [
                                                28.1,
                                                11.8
                                            ],
                                            [
                                                28.1,
                                                -7.1
                                            ],
                                            [
                                                36.2,
                                                -7.1
                                            ],
                                            [
                                                36.2,
                                                11.8
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                35.5,
                                                -7.1
                                            ],
                                            [
                                                28.6,
                                                -7.1
                                            ],
                                            [
                                                28.6,
                                                -66.6
                                            ],
                                            [
                                                35.5,
                                                -66.6
                                            ],
                                            [
                                                35.5,
                                                -7.1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                36.2,
                                                -66.6
                                            ],
                                            [
                                                28.1,
                                                -66.6
                                            ],
                                            [
                                                28.1,
                                                -84.9
                                            ],
                                            [
                                                36.2,
                                                -84.9
                                            ],
                                            [
                                                36.2,
                                                -66.6
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                2
                                            ],
                                            [
                                                2.199999999999998,
                                                0.9333333333333371
                                            ],
                                            [
                                                2.866666666666665,
                                                0
                                            ],
                                            [
                                                2.2000000000000006,
                                                -1.7999999999999972
                                            ],
                                            [
                                                0,
                                                -2.933333333333337
                                            ],
                                            [
                                                -1.5,
                                                -1.4666666666666686
                                            ],
                                            [
                                                -2.699999999999998,
                                                -0.9000000000000009
                                            ],
                                            [
                                                -3.733333333333332,
                                                -0.7999999999999972
                                            ],
                                            [
                                                -2.6333333333333306,
                                                -0.9666666666666638
                                            ],
                                            [
                                                -2.1333333333333306,
                                                -1.5666666666666675
                                            ],
                                            [
                                                -1.1999999999999982,
                                                -2.4666666666666686
                                            ],
                                            [
                                                0,
                                                -3.6666666666666665
                                            ],
                                            [
                                                2.300000000000002,
                                                -3.2999999999999994
                                            ],
                                            [
                                                4.033333333333336,
                                                -1.7666666666666666
                                            ],
                                            [
                                                5.400000000000001,
                                                0
                                            ],
                                            [
                                                4.133333333333333,
                                                2
                                            ],
                                            [
                                                2.1999999999999997,
                                                3.5666666666666664
                                            ],
                                            [
                                                0.13333333333333344,
                                                4.733333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8999999999999986,
                                                -2.6999999999999993
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -2.4333333333333322,
                                                2.0333333333333328
                                            ],
                                            [
                                                0,
                                                3.4
                                            ],
                                            [
                                                1.400000000000001,
                                                1.5
                                            ],
                                            [
                                                2.2666666666666706,
                                                0.766666666666668
                                            ],
                                            [
                                                2.733333333333332,
                                                0.5999999999999991
                                            ],
                                            [
                                                3.099999999999999,
                                                1.1666666666666667
                                            ],
                                            [
                                                2.1666666666666665,
                                                1.6333333333333304
                                            ],
                                            [
                                                1.1333333333333329,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                3.199999999999998
                                            ],
                                            [
                                                -2.0999999999999996,
                                                3.1000000000000036
                                            ],
                                            [
                                                -3.8000000000000007,
                                                1.6999999999999982
                                            ],
                                            [
                                                -5.133333333333333,
                                                0
                                            ],
                                            [
                                                -3.9333333333333322,
                                                -1.7000000000000075
                                            ],
                                            [
                                                -2.200000000000003,
                                                -3.2666666666666657
                                            ],
                                            [
                                                -0.1999999999999981,
                                                -4.599999999999999
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.13333333333333522,
                                                -3.066666666666663
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2
                                            ],
                                            [
                                                -2.200000000000003,
                                                -0.9333333333333277
                                            ],
                                            [
                                                -4.2,
                                                0
                                            ],
                                            [
                                                -2.199999999999998,
                                                1.7999999999999972
                                            ],
                                            [
                                                0,
                                                2.5333333333333314
                                            ],
                                            [
                                                1.5,
                                                1.466666666666664
                                            ],
                                            [
                                                2.7000000000000006,
                                                0.9000000000000009
                                            ],
                                            [
                                                2.933333333333337,
                                                0.6000000000000038
                                            ],
                                            [
                                                2.633333333333335,
                                                0.9666666666666686
                                            ],
                                            [
                                                2.133333333333335,
                                                1.5666666666666629
                                            ],
                                            [
                                                1.2000000000000028,
                                                2.4666666666666663
                                            ],
                                            [
                                                0,
                                                4.400000000000001
                                            ],
                                            [
                                                -2.299999999999997,
                                                3.3000000000000003
                                            ],
                                            [
                                                -4.033333333333331,
                                                1.7666666666666666
                                            ],
                                            [
                                                -5.733333333333334,
                                                0
                                            ],
                                            [
                                                -4.133333333333333,
                                                -2
                                            ],
                                            [
                                                -2.1999999999999997,
                                                -3.5666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.13333333333333405,
                                                4.9333333333333345
                                            ],
                                            [
                                                2.900000000000001,
                                                2.6999999999999993
                                            ],
                                            [
                                                4.466666666666669,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                -2.0333333333333337
                                            ],
                                            [
                                                0,
                                                -2.7999999999999994
                                            ],
                                            [
                                                -1.3999999999999961,
                                                -1.5
                                            ],
                                            [
                                                -2.2666666666666657,
                                                -0.7666666666666657
                                            ],
                                            [
                                                -3.866666666666667,
                                                -0.8666666666666695
                                            ],
                                            [
                                                -3.1000000000000014,
                                                -1.1666666666666667
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -1.6333333333333353
                                            ],
                                            [
                                                -1.1333333333333335,
                                                -2.3333333333333335
                                            ],
                                            [
                                                0,
                                                -4.066666666666667
                                            ],
                                            [
                                                2.1,
                                                -3.0999999999999943
                                            ],
                                            [
                                                3.7999999999999994,
                                                -1.7000000000000075
                                            ],
                                            [
                                                5.266666666666668,
                                                0
                                            ],
                                            [
                                                3.9333333333333322,
                                                1.6999999999999982
                                            ],
                                            [
                                                2.199999999999998,
                                                3.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                58.3,
                                                -52.1
                                            ],
                                            [
                                                46.6,
                                                -50.7
                                            ],
                                            [
                                                44.4,
                                                -58.3
                                            ],
                                            [
                                                39.1,
                                                -62.7
                                            ],
                                            [
                                                31.5,
                                                -64.1
                                            ],
                                            [
                                                21.9,
                                                -61.4
                                            ],
                                            [
                                                18.6,
                                                -54.3
                                            ],
                                            [
                                                20.85,
                                                -48.3
                                            ],
                                            [
                                                27.15,
                                                -44.75
                                            ],
                                            [
                                                36.8,
                                                -42.2
                                            ],
                                            [
                                                45.15,
                                                -39.85
                                            ],
                                            [
                                                52.3,
                                                -36.05
                                            ],
                                            [
                                                57.3,
                                                -30
                                            ],
                                            [
                                                59.1,
                                                -20.8
                                            ],
                                            [
                                                55.65,
                                                -9.25
                                            ],
                                            [
                                                46.15,
                                                -1.65
                                            ],
                                            [
                                                32,
                                                1
                                            ],
                                            [
                                                17.2,
                                                -2
                                            ],
                                            [
                                                7.7,
                                                -10.35
                                            ],
                                            [
                                                4.2,
                                                -22.8
                                            ],
                                            [
                                                15.9,
                                                -24.3
                                            ],
                                            [
                                                20.45,
                                                -12.85
                                            ],
                                            [
                                                32.4,
                                                -8.8
                                            ],
                                            [
                                                42.75,
                                                -11.85
                                            ],
                                            [
                                                46.4,
                                                -20
                                            ],
                                            [
                                                44.3,
                                                -26.45
                                            ],
                                            [
                                                38.8,
                                                -29.85
                                            ],
                                            [
                                                31.3,
                                                -31.9
                                            ],
                                            [
                                                20.85,
                                                -34.95
                                            ],
                                            [
                                                12.95,
                                                -39.15
                                            ],
                                            [
                                                8,
                                                -45.1
                                            ],
                                            [
                                                6.3,
                                                -53.4
                                            ],
                                            [
                                                9.45,
                                                -64.15
                                            ],
                                            [
                                                18.3,
                                                -71.35
                                            ],
                                            [
                                                31.7,
                                                -73.9
                                            ],
                                            [
                                                45.5,
                                                -71.35
                                            ],
                                            [
                                                54.7,
                                                -63.9
                                            ],
                                            [
                                                58.3,
                                                -52.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "4",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 66.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                52.6,
                                                0
                                            ],
                                            [
                                                40.9,
                                                0
                                            ],
                                            [
                                                40.9,
                                                -15.3
                                            ],
                                            [
                                                4.5,
                                                -15.3
                                            ],
                                            [
                                                4.5,
                                                -24.9
                                            ],
                                            [
                                                40.8,
                                                -72.9
                                            ],
                                            [
                                                52.6,
                                                -72.9
                                            ],
                                            [
                                                52.6,
                                                -25.2
                                            ],
                                            [
                                                63.8,
                                                -25.2
                                            ],
                                            [
                                                63.8,
                                                -15.3
                                            ],
                                            [
                                                52.6,
                                                -15.3
                                            ],
                                            [
                                                52.6,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                40.9,
                                                -57.6
                                            ],
                                            [
                                                16.9,
                                                -25.2
                                            ],
                                            [
                                                40.9,
                                                -25.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "9",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 63,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.633333333333335,
                                                1.6333333333333335
                                            ],
                                            [
                                                2.233333333333333,
                                                3.1
                                            ],
                                            [
                                                0.5333333333333332,
                                                4.133333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.366666666666667,
                                                -2.1666666666666665
                                            ],
                                            [
                                                -4.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.6666666666666665,
                                                2.4333333333333336
                                            ],
                                            [
                                                -1.0333333333333314,
                                                4.166666666666667
                                            ],
                                            [
                                                0.2666666666666657,
                                                5.200000000000003
                                            ],
                                            [
                                                3.4333333333333322,
                                                -1.8666666666666647
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.7000000000000006,
                                                1.9333333333333325
                                            ],
                                            [
                                                2,
                                                3.400000000000001
                                            ],
                                            [
                                                0,
                                                4.533333333333336
                                            ],
                                            [
                                                -2.166666666666667,
                                                3.633333333333335
                                            ],
                                            [
                                                -3.9,
                                                2.066666666666663
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -4.233333333333334,
                                                -3.1666666666666665
                                            ],
                                            [
                                                -2.0333333333333363,
                                                -5.76666666666667
                                            ],
                                            [
                                                0,
                                                -7.800000000000002
                                            ],
                                            [
                                                1.1666666666666667,
                                                -4.433333333333333
                                            ],
                                            [
                                                2.400000000000001,
                                                -3.266666666666667
                                            ],
                                            [
                                                3.6666666666666665,
                                                -1.7666666666666666
                                            ],
                                            [
                                                5.000000000000003,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -4.733333333333332,
                                                0
                                            ],
                                            [
                                                -3.633333333333333,
                                                -1.6333333333333335
                                            ],
                                            [
                                                -2.233333333333333,
                                                -3.099999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.40000000000000097,
                                                3.666666666666668
                                            ],
                                            [
                                                2.366666666666665,
                                                2.1666666666666665
                                            ],
                                            [
                                                4.800000000000002,
                                                0
                                            ],
                                            [
                                                2.6666666666666665,
                                                -2.4333333333333322
                                            ],
                                            [
                                                1.0333333333333314,
                                                -4.166666666666667
                                            ],
                                            [
                                                -1.2666666666666657,
                                                2.8666666666666694
                                            ],
                                            [
                                                -3.4333333333333322,
                                                1.8666666666666671
                                            ],
                                            [
                                                -4.8,
                                                0
                                            ],
                                            [
                                                -3.6999999999999993,
                                                -1.9333333333333347
                                            ],
                                            [
                                                -2.0000000000000004,
                                                -3.3999999999999964
                                            ],
                                            [
                                                0,
                                                -4.799999999999997
                                            ],
                                            [
                                                2.1666666666666665,
                                                -3.633333333333335
                                            ],
                                            [
                                                3.900000000000001,
                                                -2.066666666666672
                                            ],
                                            [
                                                6.600000000000001,
                                                0
                                            ],
                                            [
                                                4.23333333333333,
                                                3.1666666666666665
                                            ],
                                            [
                                                2.0333333333333314,
                                                5.766666666666666
                                            ],
                                            [
                                                0,
                                                5.333333333333333
                                            ],
                                            [
                                                -1.1666666666666667,
                                                4.433333333333334
                                            ],
                                            [
                                                -2.3999999999999964,
                                                3.266666666666666
                                            ],
                                            [
                                                -3.6666666666666665,
                                                1.7666666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.2,
                                                1
                                            ],
                                            [
                                                16.65,
                                                -1.45
                                            ],
                                            [
                                                7.85,
                                                -8.55
                                            ],
                                            [
                                                3.7,
                                                -19.4
                                            ],
                                            [
                                                14.7,
                                                -21.1
                                            ],
                                            [
                                                18.85,
                                                -12.35
                                            ],
                                            [
                                                29,
                                                -9.1
                                            ],
                                            [
                                                40.2,
                                                -12.75
                                            ],
                                            [
                                                45.75,
                                                -22.65
                                            ],
                                            [
                                                46.9,
                                                -36.7
                                            ],
                                            [
                                                39.85,
                                                -29.6
                                            ],
                                            [
                                                28.2,
                                                -26.8
                                            ],
                                            [
                                                15.45,
                                                -29.7
                                            ],
                                            [
                                                6.9,
                                                -37.7
                                            ],
                                            [
                                                3.9,
                                                -49.6
                                            ],
                                            [
                                                7.15,
                                                -62.25
                                            ],
                                            [
                                                16.25,
                                                -70.8
                                            ],
                                            [
                                                29.7,
                                                -73.9
                                            ],
                                            [
                                                45.95,
                                                -69.15
                                            ],
                                            [
                                                55.35,
                                                -55.75
                                            ],
                                            [
                                                58.4,
                                                -35.4
                                            ],
                                            [
                                                56.65,
                                                -20.75
                                            ],
                                            [
                                                51.3,
                                                -9.2
                                            ],
                                            [
                                                42.2,
                                                -1.65
                                            ],
                                            [
                                                29.2,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.6666666666666665,
                                                2.599999999999999
                                            ],
                                            [
                                                0,
                                                4.1333333333333355
                                            ],
                                            [
                                                2.633333333333335,
                                                2.5333333333333314
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                2.599999999999999,
                                                -2.5333333333333314
                                            ],
                                            [
                                                0,
                                                -4.200000000000003
                                            ],
                                            [
                                                -2.633333333333333,
                                                -2.4333333333333322
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                2.6666666666666665,
                                                -2.599999999999999
                                            ],
                                            [
                                                0,
                                                -4.1333333333333355
                                            ],
                                            [
                                                -2.6333333333333306,
                                                -2.5333333333333314
                                            ],
                                            [
                                                -4.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.6000000000000014,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                4.400000000000001
                                            ],
                                            [
                                                2.633333333333335,
                                                2.4333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30,
                                                -36
                                            ],
                                            [
                                                40.5,
                                                -39.9
                                            ],
                                            [
                                                44.5,
                                                -50
                                            ],
                                            [
                                                40.55,
                                                -60
                                            ],
                                            [
                                                30.1,
                                                -63.8
                                            ],
                                            [
                                                19.6,
                                                -60
                                            ],
                                            [
                                                15.7,
                                                -49.9
                                            ],
                                            [
                                                19.65,
                                                -39.65
                                            ],
                                            [
                                                30,
                                                -36
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "/",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 44.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                13.9,
                                                0
                                            ],
                                            [
                                                2.8,
                                                0
                                            ],
                                            [
                                                30.5,
                                                -72.9
                                            ],
                                            [
                                                41.6,
                                                -72.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "m",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 95.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.9333333333333322,
                                                1.5666666666666675
                                            ],
                                            [
                                                -3.3999999999999986,
                                                0
                                            ],
                                            [
                                                -3,
                                                -1.8666666666666696
                                            ],
                                            [
                                                -1.466666666666664,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -3.2666666666666657,
                                                1.9333333333333371
                                            ],
                                            [
                                                -3.866666666666665,
                                                0
                                            ],
                                            [
                                                -3.266666666666661,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                -5.86666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6999999999999982,
                                                1.9666666666666686
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.066666666666663,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.1333333333333353,
                                                -2.199999999999998
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6333333333333353,
                                                2.2333333333333343
                                            ],
                                            [
                                                3.5333333333333337,
                                                0
                                            ],
                                            [
                                                2,
                                                -1.2333333333333296
                                            ],
                                            [
                                                1.1000000000000014,
                                                -2.1666666666666665
                                            ],
                                            [
                                                0,
                                                -2.7333333333333343
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9333333333333325,
                                                -3.3333333333333335
                                            ],
                                            [
                                                2.933333333333335,
                                                -1.5666666666666675
                                            ],
                                            [
                                                3.8666666666666694,
                                                0
                                            ],
                                            [
                                                3,
                                                1.8666666666666647
                                            ],
                                            [
                                                1.7333333333333343,
                                                -3.599999999999999
                                            ],
                                            [
                                                3.2666666666666657,
                                                -1.9333333333333325
                                            ],
                                            [
                                                6.066666666666673,
                                                0
                                            ],
                                            [
                                                3.2666666666666706,
                                                3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.599999999999999
                                            ],
                                            [
                                                -1.6999999999999982,
                                                -1.966666666666664
                                            ],
                                            [
                                                -2.6000000000000036,
                                                0
                                            ],
                                            [
                                                -2.0666666666666678,
                                                1.1666666666666667
                                            ],
                                            [
                                                -1.1333333333333304,
                                                2.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.5333333333333363
                                            ],
                                            [
                                                -1.6333333333333304,
                                                -2.2333333333333294
                                            ],
                                            [
                                                -2.6666666666666665,
                                                0
                                            ],
                                            [
                                                -2,
                                                1.2333333333333343
                                            ],
                                            [
                                                -1.099999999999999,
                                                2.1666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                17.3,
                                                -56.6
                                            ],
                                            [
                                                18.1,
                                                -47.9
                                            ],
                                            [
                                                25.4,
                                                -55.25
                                            ],
                                            [
                                                34.9,
                                                -57.6
                                            ],
                                            [
                                                45.2,
                                                -54.8
                                            ],
                                            [
                                                51.9,
                                                -46.4
                                            ],
                                            [
                                                59.4,
                                                -54.7
                                            ],
                                            [
                                                70.1,
                                                -57.6
                                            ],
                                            [
                                                84.1,
                                                -52.35
                                            ],
                                            [
                                                89,
                                                -38.3
                                            ],
                                            [
                                                89,
                                                0
                                            ],
                                            [
                                                77.3,
                                                0
                                            ],
                                            [
                                                77.3,
                                                -36
                                            ],
                                            [
                                                74.75,
                                                -44.35
                                            ],
                                            [
                                                67.2,
                                                -47.3
                                            ],
                                            [
                                                60.2,
                                                -45.55
                                            ],
                                            [
                                                55.4,
                                                -40.5
                                            ],
                                            [
                                                53.7,
                                                -32.6
                                            ],
                                            [
                                                53.7,
                                                0
                                            ],
                                            [
                                                42,
                                                0
                                            ],
                                            [
                                                42,
                                                -35.3
                                            ],
                                            [
                                                39.55,
                                                -43.95
                                            ],
                                            [
                                                31.8,
                                                -47.3
                                            ],
                                            [
                                                24.8,
                                                -45.45
                                            ],
                                            [
                                                20.15,
                                                -40.35
                                            ],
                                            [
                                                18.5,
                                                -33
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ",",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 22.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333329,
                                                0.8666666666666671
                                            ],
                                            [
                                                0,
                                                1.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8333333333333346,
                                                -1.5666666666666675
                                            ],
                                            [
                                                3.133333333333333,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666671,
                                                0
                                            ],
                                            [
                                                0.6333333333333329,
                                                -0.8666666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.266666666666666
                                            ],
                                            [
                                                -1.8333333333333333,
                                                1.5666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                6.9,
                                                14.4
                                            ],
                                            [
                                                4.6,
                                                14.4
                                            ],
                                            [
                                                4.6,
                                                8.3
                                            ],
                                            [
                                                6.5,
                                                8.3
                                            ],
                                            [
                                                10.25,
                                                7
                                            ],
                                            [
                                                11.2,
                                                3.7
                                            ],
                                            [
                                                11.2,
                                                0
                                            ],
                                            [
                                                5.5,
                                                0
                                            ],
                                            [
                                                5.5,
                                                -12.3
                                            ],
                                            [
                                                17.1,
                                                -12.3
                                            ],
                                            [
                                                17.1,
                                                4.8
                                            ],
                                            [
                                                14.35,
                                                12.05
                                            ],
                                            [
                                                6.9,
                                                14.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "\r",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 0
        },
        {
            "ch": "5",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 60.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.7666666666666657,
                                                1.8
                                            ],
                                            [
                                                2.1,
                                                3.1999999999999993
                                            ],
                                            [
                                                0.39999999999999974,
                                                4.466666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.6666666666666665,
                                                -2.1999999999999993
                                            ],
                                            [
                                                -4.133333333333333,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                2.6
                                            ],
                                            [
                                                0,
                                                4.266666666666668
                                            ],
                                            [
                                                2.6333333333333306,
                                                2.4333333333333322
                                            ],
                                            [
                                                4.266666666666666,
                                                0
                                            ],
                                            [
                                                2.3999999999999986,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.1333333333333329,
                                                -1.8666666666666647
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.633333333333333,
                                                0.8333333333333334
                                            ],
                                            [
                                                -2.7333333333333343,
                                                0
                                            ],
                                            [
                                                -3.633333333333335,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2,
                                                -3.4333333333333322
                                            ],
                                            [
                                                0,
                                                -4.666666666666667
                                            ],
                                            [
                                                2.2666666666666706,
                                                -3.633333333333334
                                            ],
                                            [
                                                3.9333333333333322,
                                                -2
                                            ],
                                            [
                                                5.1333333333333355,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.133333333333333,
                                                0
                                            ],
                                            [
                                                -3.766666666666667,
                                                -1.8
                                            ],
                                            [
                                                -2.1,
                                                -3.2000000000000006
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.3333333333333333,
                                                4.466666666666666
                                            ],
                                            [
                                                2.6666666666666665,
                                                2.2000000000000006
                                            ],
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                2.5,
                                                -2.599999999999999
                                            ],
                                            [
                                                0,
                                                -4.466666666666666
                                            ],
                                            [
                                                -2.633333333333335,
                                                -2.4333333333333322
                                            ],
                                            [
                                                -2.866666666666667,
                                                0
                                            ],
                                            [
                                                -2.400000000000001,
                                                1.1666666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.7333333333333343,
                                                -1.466666666666664
                                            ],
                                            [
                                                2.633333333333333,
                                                -0.8333333333333334
                                            ],
                                            [
                                                4.799999999999997,
                                                0
                                            ],
                                            [
                                                3.633333333333335,
                                                1.9333333333333325
                                            ],
                                            [
                                                2,
                                                3.433333333333335
                                            ],
                                            [
                                                0,
                                                4.866666666666666
                                            ],
                                            [
                                                -2.2666666666666657,
                                                3.633333333333333
                                            ],
                                            [
                                                -3.9333333333333322,
                                                2
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.4,
                                                1
                                            ],
                                            [
                                                16.05,
                                                -1.7
                                            ],
                                            [
                                                7.25,
                                                -9.2
                                            ],
                                            [
                                                3.5,
                                                -20.7
                                            ],
                                            [
                                                14.7,
                                                -22.4
                                            ],
                                            [
                                                19.2,
                                                -12.4
                                            ],
                                            [
                                                29.4,
                                                -9.1
                                            ],
                                            [
                                                40.05,
                                                -13
                                            ],
                                            [
                                                43.8,
                                                -23.3
                                            ],
                                            [
                                                39.85,
                                                -33.65
                                            ],
                                            [
                                                29.5,
                                                -37.3
                                            ],
                                            [
                                                21.6,
                                                -35.55
                                            ],
                                            [
                                                16.3,
                                                -31
                                            ],
                                            [
                                                4.9,
                                                -30.9
                                            ],
                                            [
                                                10.5,
                                                -72.9
                                            ],
                                            [
                                                54.8,
                                                -72.9
                                            ],
                                            [
                                                54.8,
                                                -62.7
                                            ],
                                            [
                                                20,
                                                -62.7
                                            ],
                                            [
                                                17,
                                                -41.6
                                            ],
                                            [
                                                23.55,
                                                -45.05
                                            ],
                                            [
                                                31.6,
                                                -46.3
                                            ],
                                            [
                                                44.25,
                                                -43.4
                                            ],
                                            [
                                                52.7,
                                                -35.35
                                            ],
                                            [
                                                55.7,
                                                -23.2
                                            ],
                                            [
                                                52.3,
                                                -10.45
                                            ],
                                            [
                                                43,
                                                -2
                                            ],
                                            [
                                                29.4,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "0",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 64.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4,
                                                3.1333333333333333
                                            ],
                                            [
                                                1.8333333333333333,
                                                5.633333333333334
                                            ],
                                            [
                                                0,
                                                7.466666666666666
                                            ],
                                            [
                                                -2.2000000000000006,
                                                5.5
                                            ],
                                            [
                                                -4.066666666666667,
                                                2.6000000000000036
                                            ],
                                            [
                                                -5.533333333333336,
                                                0
                                            ],
                                            [
                                                -4,
                                                -3.133333333333335
                                            ],
                                            [
                                                -1.8333333333333333,
                                                -5.599999999999999
                                            ],
                                            [
                                                0,
                                                -7.466666666666669
                                            ],
                                            [
                                                2.2333333333333343,
                                                -5.533333333333332
                                            ],
                                            [
                                                4.033333333333336,
                                                -2.6
                                            ],
                                            [
                                                5.599999999999999,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.400000000000001,
                                                0
                                            ],
                                            [
                                                -4.000000000000001,
                                                -3.1333333333333333
                                            ],
                                            [
                                                -1.8333333333333333,
                                                -5.633333333333333
                                            ],
                                            [
                                                0,
                                                -8.733333333333334
                                            ],
                                            [
                                                2.1999999999999993,
                                                -5.499999999999996
                                            ],
                                            [
                                                4.0666666666666655,
                                                -2.6000000000000036
                                            ],
                                            [
                                                6.466666666666664,
                                                0
                                            ],
                                            [
                                                4,
                                                3.133333333333335
                                            ],
                                            [
                                                1.8333333333333333,
                                                5.599999999999999
                                            ],
                                            [
                                                0,
                                                8.733333333333334
                                            ],
                                            [
                                                -2.2333333333333294,
                                                5.533333333333334
                                            ],
                                            [
                                                -4.033333333333331,
                                                2.6
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.2,
                                                1
                                            ],
                                            [
                                                16.6,
                                                -3.7
                                            ],
                                            [
                                                7.85,
                                                -16.85
                                            ],
                                            [
                                                5.1,
                                                -36.5
                                            ],
                                            [
                                                8.4,
                                                -57.85
                                            ],
                                            [
                                                17.8,
                                                -70
                                            ],
                                            [
                                                32.2,
                                                -73.9
                                            ],
                                            [
                                                47.9,
                                                -69.2
                                            ],
                                            [
                                                56.65,
                                                -56.1
                                            ],
                                            [
                                                59.4,
                                                -36.5
                                            ],
                                            [
                                                56.05,
                                                -15.1
                                            ],
                                            [
                                                46.65,
                                                -2.9
                                            ],
                                            [
                                                32.2,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.200000000000003,
                                                2.1666666666666665
                                            ],
                                            [
                                                -1,
                                                4.0666666666666655
                                            ],
                                            [
                                                0,
                                                5.666666666666667
                                            ],
                                            [
                                                1.2666666666666657,
                                                3.9333333333333322
                                            ],
                                            [
                                                2.300000000000002,
                                                1.6333333333333304
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                2.233333333333332,
                                                -2.1666666666666665
                                            ],
                                            [
                                                0.9666666666666662,
                                                -4.033333333333336
                                            ],
                                            [
                                                0,
                                                -5.666666666666667
                                            ],
                                            [
                                                -1.2666666666666657,
                                                -3.9666666666666686
                                            ],
                                            [
                                                -2.300000000000002,
                                                -1.6333333333333329
                                            ],
                                            [
                                                -2.933333333333335,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.7333333333333294,
                                                0
                                            ],
                                            [
                                                2.199999999999998,
                                                -2.1666666666666665
                                            ],
                                            [
                                                1,
                                                -4.066666666666667
                                            ],
                                            [
                                                0,
                                                -6.933333333333333
                                            ],
                                            [
                                                -1.2666666666666657,
                                                -3.933333333333337
                                            ],
                                            [
                                                -2.299999999999997,
                                                -1.6333333333333353
                                            ],
                                            [
                                                -3.666666666666669,
                                                0
                                            ],
                                            [
                                                -2.2333333333333343,
                                                2.1666666666666665
                                            ],
                                            [
                                                -0.9666666666666662,
                                                4.033333333333331
                                            ],
                                            [
                                                0,
                                                6.933333333333333
                                            ],
                                            [
                                                1.2666666666666657,
                                                3.9666666666666663
                                            ],
                                            [
                                                2.2999999999999994,
                                                1.6333333333333329
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.2,
                                                -9.3
                                            ],
                                            [
                                                41.1,
                                                -12.55
                                            ],
                                            [
                                                45.9,
                                                -21.9
                                            ],
                                            [
                                                47.4,
                                                -36.5
                                            ],
                                            [
                                                45.5,
                                                -52.8
                                            ],
                                            [
                                                40.15,
                                                -61.15
                                            ],
                                            [
                                                32.2,
                                                -63.6
                                            ],
                                            [
                                                23.35,
                                                -60.35
                                            ],
                                            [
                                                18.55,
                                                -51.05
                                            ],
                                            [
                                                17.1,
                                                -36.5
                                            ],
                                            [
                                                19,
                                                -20.15
                                            ],
                                            [
                                                24.35,
                                                -11.75
                                            ],
                                            [
                                                32.2,
                                                -9.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "s",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 54.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.233333333333333,
                                                3.3000000000000003
                                            ],
                                            [
                                                0.2666666666666666,
                                                5.733333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                -2.1
                                            ],
                                            [
                                                -4.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.0666666666666678,
                                                1.2333333333333332
                                            ],
                                            [
                                                0,
                                                2.8000000000000007
                                            ],
                                            [
                                                0.8333333333333334,
                                                1.0333333333333339
                                            ],
                                            [
                                                1.5,
                                                0.5999999999999991
                                            ],
                                            [
                                                2,
                                                0.40000000000000097
                                            ],
                                            [
                                                2.3333333333333335,
                                                0.4666666666666662
                                            ],
                                            [
                                                2.5333333333333337,
                                                1.3666666666666647
                                            ],
                                            [
                                                1.2666666666666668,
                                                2.133333333333333
                                            ],
                                            [
                                                0,
                                                2.9333333333333322
                                            ],
                                            [
                                                -1.8000000000000007,
                                                2.4666666666666637
                                            ],
                                            [
                                                -3.2999999999999994,
                                                1.3666666666666647
                                            ],
                                            [
                                                -4.466666666666669,
                                                0
                                            ],
                                            [
                                                -3.300000000000002,
                                                -1.3000000000000018
                                            ],
                                            [
                                                -1.8999999999999961,
                                                -2.5333333333333363
                                            ],
                                            [
                                                -0.2666666666666657,
                                                -3.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9666666666666686,
                                                1.8666666666666647
                                            ],
                                            [
                                                4.000000000000003,
                                                0
                                            ],
                                            [
                                                1.7333333333333343,
                                                -1.3333333333333333
                                            ],
                                            [
                                                0,
                                                -2.066666666666663
                                            ],
                                            [
                                                -1.099999999999999,
                                                -1.099999999999999
                                            ],
                                            [
                                                -2.2999999999999994,
                                                -0.6666666666666666
                                            ],
                                            [
                                                -3.5333333333333314,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -2.2666666666666657,
                                                -0.766666666666668
                                            ],
                                            [
                                                -1.599999999999999,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -0.8666666666666648,
                                                -1.9333333333333347
                                            ],
                                            [
                                                0,
                                                -2.866666666666667
                                            ],
                                            [
                                                3.900000000000001,
                                                -3.1333333333333333
                                            ],
                                            [
                                                8,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -7.266666666666666,
                                                0
                                            ],
                                            [
                                                -4.233333333333333,
                                                -3.3000000000000003
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.3333333333333335
                                            ],
                                            [
                                                2.3333333333333335,
                                                2.1
                                            ],
                                            [
                                                3.3999999999999986,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                -1.2333333333333332
                                            ],
                                            [
                                                0,
                                                -1.7333333333333332
                                            ],
                                            [
                                                -0.8333333333333334,
                                                -1.0333333333333339
                                            ],
                                            [
                                                -1.5,
                                                -0.5999999999999991
                                            ],
                                            [
                                                -2,
                                                -0.40000000000000097
                                            ],
                                            [
                                                -3.7333333333333343,
                                                -0.8666666666666671
                                            ],
                                            [
                                                -2.5333333333333328,
                                                -1.3666666666666671
                                            ],
                                            [
                                                -1.2666666666666668,
                                                -2.133333333333335
                                            ],
                                            [
                                                0,
                                                -3.400000000000001
                                            ],
                                            [
                                                1.7999999999999996,
                                                -2.4666666666666686
                                            ],
                                            [
                                                3.2999999999999994,
                                                -1.3666666666666696
                                            ],
                                            [
                                                4.466666666666664,
                                                0
                                            ],
                                            [
                                                3.300000000000002,
                                                1.2999999999999972
                                            ],
                                            [
                                                1.900000000000001,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.133333333333335
                                            ],
                                            [
                                                -1.966666666666664,
                                                -1.8666666666666647
                                            ],
                                            [
                                                -3.133333333333333,
                                                0
                                            ],
                                            [
                                                -1.7333333333333318,
                                                1.3333333333333333
                                            ],
                                            [
                                                0,
                                                1.8666666666666696
                                            ],
                                            [
                                                1.1000000000000014,
                                                1.099999999999999
                                            ],
                                            [
                                                2.2999999999999994,
                                                0.6666666666666666
                                            ],
                                            [
                                                2.7333333333333343,
                                                0.5333333333333314
                                            ],
                                            [
                                                2.2666666666666706,
                                                0.766666666666668
                                            ],
                                            [
                                                1.599999999999999,
                                                1.2666666666666657
                                            ],
                                            [
                                                0.8666666666666695,
                                                1.9333333333333325
                                            ],
                                            [
                                                0,
                                                5.066666666666666
                                            ],
                                            [
                                                -3.900000000000001,
                                                3.1333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27.4,
                                                1
                                            ],
                                            [
                                                10.15,
                                                -3.95
                                            ],
                                            [
                                                3.4,
                                                -17.5
                                            ],
                                            [
                                                14.7,
                                                -18.8
                                            ],
                                            [
                                                18.2,
                                                -10.65
                                            ],
                                            [
                                                27.8,
                                                -7.5
                                            ],
                                            [
                                                36,
                                                -9.35
                                            ],
                                            [
                                                39.1,
                                                -15.4
                                            ],
                                            [
                                                37.85,
                                                -19.55
                                            ],
                                            [
                                                34.35,
                                                -22
                                            ],
                                            [
                                                29.1,
                                                -23.5
                                            ],
                                            [
                                                22.6,
                                                -24.8
                                            ],
                                            [
                                                13.2,
                                                -28.15
                                            ],
                                            [
                                                7.5,
                                                -33.4
                                            ],
                                            [
                                                5.6,
                                                -41
                                            ],
                                            [
                                                8.3,
                                                -49.8
                                            ],
                                            [
                                                15.95,
                                                -55.55
                                            ],
                                            [
                                                27.6,
                                                -57.6
                                            ],
                                            [
                                                39.25,
                                                -55.65
                                            ],
                                            [
                                                47.05,
                                                -49.9
                                            ],
                                            [
                                                50.3,
                                                -40.5
                                            ],
                                            [
                                                39.1,
                                                -39
                                            ],
                                            [
                                                36.15,
                                                -46.5
                                            ],
                                            [
                                                27.2,
                                                -49.3
                                            ],
                                            [
                                                19.9,
                                                -47.3
                                            ],
                                            [
                                                17.3,
                                                -42.2
                                            ],
                                            [
                                                18.95,
                                                -37.75
                                            ],
                                            [
                                                24.05,
                                                -35.1
                                            ],
                                            [
                                                32.8,
                                                -33
                                            ],
                                            [
                                                40.3,
                                                -31.05
                                            ],
                                            [
                                                46.1,
                                                -28
                                            ],
                                            [
                                                49.8,
                                                -23.2
                                            ],
                                            [
                                                51.1,
                                                -16
                                            ],
                                            [
                                                45.25,
                                                -3.7
                                            ],
                                            [
                                                27.4,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "g",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.9666666666666663,
                                                2.866666666666667
                                            ],
                                            [
                                                0.5333333333333332,
                                                4.733333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.1666666666666667,
                                                -1.4000000000000001
                                            ],
                                            [
                                                -1.8666666666666647,
                                                -0.566666666666667
                                            ],
                                            [
                                                -2.2000000000000006,
                                                0
                                            ],
                                            [
                                                -2.633333333333335,
                                                2.033333333333333
                                            ],
                                            [
                                                0,
                                                4.6000000000000005
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.9333333333333322,
                                                -1.3666666666666665
                                            ],
                                            [
                                                3.866666666666667,
                                                0
                                            ],
                                            [
                                                3.5000000000000013,
                                                2.1666666666666665
                                            ],
                                            [
                                                1.8999999999999997,
                                                3.866666666666666
                                            ],
                                            [
                                                0,
                                                5.2
                                            ],
                                            [
                                                -1.866666666666667,
                                                3.9333333333333322
                                            ],
                                            [
                                                -3.4,
                                                2.2333333333333343
                                            ],
                                            [
                                                -4.666666666666667,
                                                0
                                            ],
                                            [
                                                -3.199999999999998,
                                                -1.7666666666666657
                                            ],
                                            [
                                                -1.4666666666666686,
                                                -3.066666666666663
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.900000000000001,
                                                -3.3000000000000003
                                            ],
                                            [
                                                3.900000000000001,
                                                -1.8333333333333333
                                            ],
                                            [
                                                6.133333333333333,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.733333333333334,
                                                0
                                            ],
                                            [
                                                -3.966666666666667,
                                                -2.866666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.2666666666666681,
                                                2.3333333333333335
                                            ],
                                            [
                                                1.1666666666666667,
                                                1.3999999999999997
                                            ],
                                            [
                                                1.8666666666666671,
                                                0.5666666666666664
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                2.6333333333333306,
                                                -2.0333333333333337
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7333333333333343,
                                                2.9333333333333336
                                            ],
                                            [
                                                -2.9333333333333322,
                                                1.3666666666666665
                                            ],
                                            [
                                                -4.733333333333332,
                                                0
                                            ],
                                            [
                                                -3.5,
                                                -2.1666666666666665
                                            ],
                                            [
                                                -1.9000000000000001,
                                                -3.866666666666667
                                            ],
                                            [
                                                0,
                                                -5.2
                                            ],
                                            [
                                                1.8666666666666665,
                                                -3.9333333333333322
                                            ],
                                            [
                                                3.4,
                                                -2.2333333333333343
                                            ],
                                            [
                                                4.000000000000003,
                                                0
                                            ],
                                            [
                                                3.199999999999998,
                                                1.7666666666666704
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.333333333333333
                                            ],
                                            [
                                                -1.8999999999999961,
                                                3.2999999999999994
                                            ],
                                            [
                                                -3.900000000000001,
                                                1.8333333333333346
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.3,
                                                17.6
                                            ],
                                            [
                                                13.25,
                                                13.3
                                            ],
                                            [
                                                6.5,
                                                1.9
                                            ],
                                            [
                                                17.2,
                                                -0.4
                                            ],
                                            [
                                                19.35,
                                                5.2
                                            ],
                                            [
                                                23.9,
                                                8.15
                                            ],
                                            [
                                                30,
                                                9
                                            ],
                                            [
                                                40.45,
                                                5.95
                                            ],
                                            [
                                                44.4,
                                                -4
                                            ],
                                            [
                                                44.4,
                                                -13.9
                                            ],
                                            [
                                                37.4,
                                                -7.45
                                            ],
                                            [
                                                27.2,
                                                -5.4
                                            ],
                                            [
                                                14.85,
                                                -8.65
                                            ],
                                            [
                                                6.75,
                                                -17.7
                                            ],
                                            [
                                                3.9,
                                                -31.3
                                            ],
                                            [
                                                6.7,
                                                -45
                                            ],
                                            [
                                                14.6,
                                                -54.25
                                            ],
                                            [
                                                26.7,
                                                -57.6
                                            ],
                                            [
                                                37.5,
                                                -54.95
                                            ],
                                            [
                                                44.5,
                                                -47.7
                                            ],
                                            [
                                                45.1,
                                                -56.6
                                            ],
                                            [
                                                55.9,
                                                -56.6
                                            ],
                                            [
                                                55.9,
                                                -4.3
                                            ],
                                            [
                                                53.05,
                                                7.15
                                            ],
                                            [
                                                44.35,
                                                14.85
                                            ],
                                            [
                                                29.3,
                                                17.6
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.133333333333335,
                                                1.3666666666666671
                                            ],
                                            [
                                                -1.2333333333333296,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                3
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.2333333333333343,
                                                2.2333333333333343
                                            ],
                                            [
                                                2.200000000000003,
                                                1.3000000000000018
                                            ],
                                            [
                                                3,
                                                0
                                            ],
                                            [
                                                2.400000000000001,
                                                -3.0666666666666678
                                            ],
                                            [
                                                0,
                                                -5.2
                                            ],
                                            [
                                                -2.3999999999999986,
                                                -3.2000000000000006
                                            ],
                                            [
                                                -4.599999999999999,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                2.9333333333333322,
                                                0
                                            ],
                                            [
                                                2.133333333333335,
                                                -1.3666666666666671
                                            ],
                                            [
                                                1.2333333333333343,
                                                -2.3333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3
                                            ],
                                            [
                                                -1.2333333333333296,
                                                -2.2333333333333294
                                            ],
                                            [
                                                -2.199999999999998,
                                                -1.3000000000000018
                                            ],
                                            [
                                                -4.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.3999999999999986,
                                                3.0666666666666678
                                            ],
                                            [
                                                0,
                                                5.0666666666666655
                                            ],
                                            [
                                                2.400000000000001,
                                                3.2000000000000006
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.9,
                                                -14
                                            ],
                                            [
                                                37.5,
                                                -16.05
                                            ],
                                            [
                                                42.55,
                                                -21.6
                                            ],
                                            [
                                                44.4,
                                                -29.6
                                            ],
                                            [
                                                44.4,
                                                -33.1
                                            ],
                                            [
                                                42.55,
                                                -40.95
                                            ],
                                            [
                                                37.4,
                                                -46.25
                                            ],
                                            [
                                                29.6,
                                                -48.2
                                            ],
                                            [
                                                19.4,
                                                -43.6
                                            ],
                                            [
                                                15.8,
                                                -31.2
                                            ],
                                            [
                                                19.4,
                                                -18.8
                                            ],
                                            [
                                                29.9,
                                                -14
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "i",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 25.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                18.5,
                                                -56.6
                                            ],
                                            [
                                                18.5,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.7,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -78.8
                                            ],
                                            [
                                                18.7,
                                                -78.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ".",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 22.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.1,
                                                0
                                            ],
                                            [
                                                5.5,
                                                0
                                            ],
                                            [
                                                5.5,
                                                -12.3
                                            ],
                                            [
                                                17.1,
                                                -12.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ],
    "assets": [
        {
            "nm": "animation",
            "id": "1",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Isometric",
                    "sr": 1,
                    "st": 1,
                    "op": 4840,
                    "ip": 1,
                    "ln": "31857",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 1,
                            "k": [
                                {
                                    "s": [
                                        10,
                                        10
                                    ],
                                    "i": {
                                        "x": [
                                            0.833,
                                            0.833
                                        ],
                                        "y": [
                                            1,
                                            1
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0,
                                            0
                                        ],
                                        "y": [
                                            0,
                                            0
                                        ]
                                    },
                                    "t": 3
                                },
                                {
                                    "s": [
                                        70,
                                        70
                                    ],
                                    "i": {
                                        "x": [
                                            0.667,
                                            0.667
                                        ],
                                        "y": [
                                            1,
                                            1
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167,
                                            0.167
                                        ],
                                        "y": [
                                            0,
                                            0
                                        ]
                                    },
                                    "t": 47
                                }
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                387.4,
                                243.368
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "2",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "Dots line",
                    "sr": 1,
                    "st": 121,
                    "op": 4960,
                    "ip": 121,
                    "ln": "31858",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                417
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "3",
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "AI Chat ",
                    "sr": 1,
                    "st": 221,
                    "op": 5060,
                    "ip": 221,
                    "ln": "31856",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                736
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "4",
                    "ind": 3
                },
                {
                    "ty": 0,
                    "nm": "Webpage",
                    "sr": 1,
                    "st": 221,
                    "op": 5060,
                    "ip": 221,
                    "ln": "31855",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                726
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "12",
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Isometric",
            "id": "2",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "SVG 5 Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31743",
                    "tt": 1,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                32.5,
                                37
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                257,
                                257
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        423.2,
                                        391.265
                                    ],
                                    "t": 1
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        576.397,
                                        476.659
                                    ],
                                    "t": 104.999
                                },
                                {
                                    "s": [
                                        423.996,
                                        389.671
                                    ],
                                    "t": 225.998
                                }
                            ],
                            "x": "var $bm_rt;\n$bm_rt = loopOut();"
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.783,
                                                    -9.045
                                                ],
                                                [
                                                    15.783,
                                                    27.182
                                                ],
                                                [
                                                    -15.783,
                                                    8.958
                                                ],
                                                [
                                                    -15.783,
                                                    -27.095
                                                ],
                                                [
                                                    -15.633,
                                                    -27.182
                                                ],
                                                [
                                                    0.147,
                                                    -18.072
                                                ],
                                                [
                                                    15.589,
                                                    -9.156
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            16.283,
                                            45.993
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.783,
                                                    -27.225
                                                ],
                                                [
                                                    15.783,
                                                    9.001
                                                ],
                                                [
                                                    -15.783,
                                                    27.225
                                                ],
                                                [
                                                    -15.783,
                                                    -9.001
                                                ],
                                                [
                                                    -15.59,
                                                    -9.112
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            47.847,
                                            45.95
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.491,
                                                    0.056
                                                ],
                                                [
                                                    0.118,
                                                    18.169
                                                ],
                                                [
                                                    -0.075,
                                                    18.058
                                                ],
                                                [
                                                    -0.268,
                                                    18.169
                                                ],
                                                [
                                                    -15.71,
                                                    9.252
                                                ],
                                                [
                                                    -31.491,
                                                    0.142
                                                ],
                                                [
                                                    -30.805,
                                                    -0.254
                                                ],
                                                [
                                                    -30.805,
                                                    -0.427
                                                ],
                                                [
                                                    -15.024,
                                                    -9.537
                                                ],
                                                [
                                                    -0.075,
                                                    -18.169
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            32.14,
                                            18.669
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1,
                    "tp": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 3",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31742",
                    "hasMask": false,
                    "td": 1,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                158.24,
                                92.747
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100.931,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                540.24,
                                458.747
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    7.39,
                                                    -5.964
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -7.391,
                                                    5.963
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    104.193,
                                                    -15.138
                                                ],
                                                [
                                                    35.643,
                                                    15.998
                                                ],
                                                [
                                                    31.912,
                                                    109.477
                                                ],
                                                [
                                                    27.16,
                                                    228.526
                                                ],
                                                [
                                                    437.349,
                                                    108.676
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            117.067,
                                            150.728
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31741",
                    "hasMask": false,
                    "td": 1,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -188.179,
                                                    35.62
                                                ],
                                                [
                                                    -272.525,
                                                    207.151
                                                ],
                                                [
                                                    -84.388,
                                                    255.188
                                                ],
                                                [
                                                    -85.826,
                                                    92.203
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            98.77,
                                            103.543
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0.336,
                                            0.109
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "SVG 4svg Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31740",
                    "tt": 1,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                16.5,
                                19
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                260,
                                260
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        299.81,
                                        461.227
                                    ],
                                    "t": 0
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        215.465,
                                        514.449
                                    ],
                                    "t": 107.999
                                },
                                {
                                    "s": [
                                        299.81,
                                        461.227
                                    ],
                                    "t": 222.998
                                }
                            ],
                            "x": "var $bm_rt;\n$bm_rt = loopOut();"
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.89,
                                                    -4.502
                                                ],
                                                [
                                                    7.89,
                                                    13.612
                                                ],
                                                [
                                                    -7.89,
                                                    4.502
                                                ],
                                                [
                                                    -7.89,
                                                    -13.612
                                                ],
                                                [
                                                    7.794,
                                                    -4.555
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            8.39,
                                            23.226
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.893,
                                                    -13.612
                                                ],
                                                [
                                                    7.893,
                                                    4.502
                                                ],
                                                [
                                                    -7.893,
                                                    13.612
                                                ],
                                                [
                                                    -7.893,
                                                    -4.502
                                                ],
                                                [
                                                    -7.796,
                                                    -4.555
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            24.172,
                                            23.226
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.783,
                                                    0.029
                                                ],
                                                [
                                                    0.094,
                                                    9.086
                                                ],
                                                [
                                                    -0.002,
                                                    9.028
                                                ],
                                                [
                                                    -0.099,
                                                    9.086
                                                ],
                                                [
                                                    -15.783,
                                                    0.029
                                                ],
                                                [
                                                    -0.002,
                                                    -9.086
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            16.283,
                                            9.586
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4,
                    "tp": 3
                },
                {
                    "ty": 4,
                    "nm": "SVG 3 Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31739",
                    "tt": 1,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                32.5,
                                37
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                260,
                                260
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        300.218,
                                        319.603
                                    ],
                                    "t": 1
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 1
                                    },
                                    "s": [
                                        192.096,
                                        258.949
                                    ],
                                    "t": 105.999
                                },
                                {
                                    "s": [
                                        300.218,
                                        319.603
                                    ],
                                    "t": 223.998
                                }
                            ],
                            "x": "var $bm_rt;\n$bm_rt = loopOut();"
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.783,
                                                    -9.001
                                                ],
                                                [
                                                    15.783,
                                                    27.225
                                                ],
                                                [
                                                    -15.783,
                                                    9.001
                                                ],
                                                [
                                                    -15.783,
                                                    -27.225
                                                ],
                                                [
                                                    15.589,
                                                    -9.112
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            16.283,
                                            45.95
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.783,
                                                    -27.225
                                                ],
                                                [
                                                    15.783,
                                                    9.001
                                                ],
                                                [
                                                    -15.783,
                                                    27.225
                                                ],
                                                [
                                                    -15.783,
                                                    -9.001
                                                ],
                                                [
                                                    -15.59,
                                                    -9.112
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            47.847,
                                            45.95
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.565,
                                                    0.056
                                                ],
                                                [
                                                    0.193,
                                                    18.169
                                                ],
                                                [
                                                    0,
                                                    18.058
                                                ],
                                                [
                                                    -0.193,
                                                    18.169
                                                ],
                                                [
                                                    -31.565,
                                                    0.056
                                                ],
                                                [
                                                    0,
                                                    -18.169
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            32.065,
                                            18.669
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 5,
                    "tp": 6
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31738",
                    "hasMask": false,
                    "td": 1,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                106.225,
                                102
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -251.772,
                                                    -239.928
                                                ],
                                                [
                                                    -290.293,
                                                    -183.378
                                                ],
                                                [
                                                    -369.159,
                                                    -103.311
                                                ],
                                                [
                                                    -88.833,
                                                    41.915
                                                ],
                                                [
                                                    -87.408,
                                                    -49.213
                                                ],
                                                [
                                                    -0.503,
                                                    -94.056
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            90.605,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": -1.111
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 6
                },
                {
                    "ty": 4,
                    "nm": "SVG 1 Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31737",
                    "hasMask": true,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                64,
                                73.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                260,
                                260
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "masksProperties": [
                        {
                            "nm": "Mask 1",
                            "inv": false,
                            "mode": "s",
                            "x": {
                                "a": 0,
                                "k": 0
                            },
                            "o": {
                                "a": 0,
                                "k": 100
                            },
                            "pt": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            63.613,
                                            -1.057
                                        ],
                                        [
                                            46.513,
                                            8.268
                                        ],
                                        [
                                            65.674,
                                            19.369
                                        ],
                                        [
                                            82.095,
                                            9.481
                                        ]
                                    ]
                                }
                            }
                        }
                    ],
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.706,
                                                    -0.087
                                                ],
                                                [
                                                    15.02,
                                                    0.309
                                                ],
                                                [
                                                    15.02,
                                                    0.483
                                                ],
                                                [
                                                    -15.706,
                                                    18.224
                                                ],
                                                [
                                                    -15.706,
                                                    -18.224
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            95.116,
                                            100.727
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.563,
                                                    -54.668
                                                ],
                                                [
                                                    31.563,
                                                    -0.174
                                                ],
                                                [
                                                    15.783,
                                                    8.936
                                                ],
                                                [
                                                    15.783,
                                                    -27.334
                                                ],
                                                [
                                                    -15.778,
                                                    -9.114
                                                ],
                                                [
                                                    -15.778,
                                                    27.334
                                                ],
                                                [
                                                    14.948,
                                                    9.593
                                                ],
                                                [
                                                    14.948,
                                                    27.812
                                                ],
                                                [
                                                    -31.563,
                                                    54.668
                                                ],
                                                [
                                                    -31.563,
                                                    -18.224
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            95.188,
                                            91.617
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.563,
                                                    -27.334
                                                ],
                                                [
                                                    31.563,
                                                    45.559
                                                ],
                                                [
                                                    0.002,
                                                    27.335
                                                ],
                                                [
                                                    0.002,
                                                    9.109
                                                ],
                                                [
                                                    -15.778,
                                                    -0.001
                                                ],
                                                [
                                                    -15.778,
                                                    18.224
                                                ],
                                                [
                                                    -31.563,
                                                    9.109
                                                ],
                                                [
                                                    -31.563,
                                                    -27.334
                                                ],
                                                [
                                                    0.002,
                                                    -9.11
                                                ],
                                                [
                                                    0.002,
                                                    -45.559
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            32.063,
                                            100.727
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.78,
                                                    0.002
                                                ],
                                                [
                                                    -15.78,
                                                    18.222
                                                ],
                                                [
                                                    -15.78,
                                                    -18.222
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            47.845,
                                            36.946
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.783,
                                                    -18.224
                                                ],
                                                [
                                                    15.783,
                                                    18.224
                                                ],
                                                [
                                                    -15.783,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            16.283,
                                            73.392
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    47.343,
                                                    0.002
                                                ],
                                                [
                                                    -15.783,
                                                    36.446
                                                ],
                                                [
                                                    -47.343,
                                                    18.222
                                                ],
                                                [
                                                    -15.783,
                                                    0.002
                                                ],
                                                [
                                                    -47.343,
                                                    -18.222
                                                ],
                                                [
                                                    -15.783,
                                                    -36.446
                                                ],
                                                [
                                                    -0.93,
                                                    -27.873
                                                ],
                                                [
                                                    0.003,
                                                    -27.337
                                                ],
                                                [
                                                    -15.783,
                                                    -18.222
                                                ],
                                                [
                                                    0.003,
                                                    -9.112
                                                ],
                                                [
                                                    15.783,
                                                    -18.222
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            79.408,
                                            36.946
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 7
                },
                {
                    "ty": 4,
                    "nm": "SVG 2 Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31736",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                16.283,
                                18.669
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                253,
                                253
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        420.965,
                                        246.272
                                    ],
                                    "t": 0
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        422.939,
                                        144.535
                                    ],
                                    "t": 103.999
                                },
                                {
                                    "s": [
                                        420.965,
                                        246.272
                                    ],
                                    "t": 222.998
                                }
                            ],
                            "x": "var $bm_rt;\n$bm_rt = loopOut();"
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.89,
                                                    -4.502
                                                ],
                                                [
                                                    7.89,
                                                    13.612
                                                ],
                                                [
                                                    -7.89,
                                                    4.502
                                                ],
                                                [
                                                    -7.89,
                                                    -13.612
                                                ],
                                                [
                                                    7.794,
                                                    -4.555
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            8.39,
                                            23.226
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.893,
                                                    -13.612
                                                ],
                                                [
                                                    7.893,
                                                    4.502
                                                ],
                                                [
                                                    -7.893,
                                                    13.612
                                                ],
                                                [
                                                    -7.893,
                                                    -4.502
                                                ],
                                                [
                                                    -7.796,
                                                    -4.555
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            24.172,
                                            23.226
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.783,
                                                    0.029
                                                ],
                                                [
                                                    0.094,
                                                    9.086
                                                ],
                                                [
                                                    -0.002,
                                                    9.028
                                                ],
                                                [
                                                    -0.099,
                                                    9.086
                                                ],
                                                [
                                                    -15.783,
                                                    0.029
                                                ],
                                                [
                                                    -0.002,
                                                    -9.086
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            16.283,
                                            9.586
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 8
                },
                {
                    "ty": 4,
                    "nm": "SVG 1 Outlines 2",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31735",
                    "hasMask": true,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                64,
                                73.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                260,
                                260
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "masksProperties": [
                        {
                            "nm": "Mask 1",
                            "inv": false,
                            "mode": "a",
                            "x": {
                                "a": 0,
                                "k": 0
                            },
                            "o": {
                                "a": 0,
                                "k": 100
                            },
                            "pt": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            63.252,
                                            -0.618
                                        ],
                                        [
                                            46.153,
                                            8.707
                                        ],
                                        [
                                            64.316,
                                            20.296
                                        ],
                                        [
                                            80.972,
                                            9.394
                                        ]
                                    ]
                                }
                            }
                        }
                    ],
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.706,
                                                    -0.087
                                                ],
                                                [
                                                    15.02,
                                                    0.309
                                                ],
                                                [
                                                    15.02,
                                                    0.483
                                                ],
                                                [
                                                    -15.706,
                                                    18.224
                                                ],
                                                [
                                                    -15.706,
                                                    -18.224
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            95.116,
                                            100.727
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.563,
                                                    -54.668
                                                ],
                                                [
                                                    31.563,
                                                    -0.174
                                                ],
                                                [
                                                    15.783,
                                                    8.936
                                                ],
                                                [
                                                    15.783,
                                                    -27.334
                                                ],
                                                [
                                                    -15.778,
                                                    -9.114
                                                ],
                                                [
                                                    -15.778,
                                                    27.334
                                                ],
                                                [
                                                    14.948,
                                                    9.593
                                                ],
                                                [
                                                    14.948,
                                                    27.812
                                                ],
                                                [
                                                    -31.563,
                                                    54.668
                                                ],
                                                [
                                                    -31.563,
                                                    -18.224
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            95.188,
                                            91.617
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    31.563,
                                                    -27.334
                                                ],
                                                [
                                                    31.563,
                                                    45.559
                                                ],
                                                [
                                                    0.002,
                                                    27.335
                                                ],
                                                [
                                                    0.002,
                                                    9.109
                                                ],
                                                [
                                                    -15.778,
                                                    -0.001
                                                ],
                                                [
                                                    -15.778,
                                                    18.224
                                                ],
                                                [
                                                    -31.563,
                                                    9.109
                                                ],
                                                [
                                                    -31.563,
                                                    -27.334
                                                ],
                                                [
                                                    0.002,
                                                    -9.11
                                                ],
                                                [
                                                    0.002,
                                                    -45.559
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            32.063,
                                            100.727
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.78,
                                                    0.002
                                                ],
                                                [
                                                    -15.78,
                                                    18.222
                                                ],
                                                [
                                                    -15.78,
                                                    -18.222
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            47.845,
                                            36.946
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.783,
                                                    -18.224
                                                ],
                                                [
                                                    15.783,
                                                    18.224
                                                ],
                                                [
                                                    -15.783,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            16.283,
                                            73.392
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    47.343,
                                                    0.002
                                                ],
                                                [
                                                    -15.783,
                                                    36.446
                                                ],
                                                [
                                                    -47.343,
                                                    18.222
                                                ],
                                                [
                                                    -15.783,
                                                    0.002
                                                ],
                                                [
                                                    -47.343,
                                                    -18.222
                                                ],
                                                [
                                                    -15.783,
                                                    -36.446
                                                ],
                                                [
                                                    -0.93,
                                                    -27.873
                                                ],
                                                [
                                                    0.003,
                                                    -27.337
                                                ],
                                                [
                                                    -15.783,
                                                    -18.222
                                                ],
                                                [
                                                    0.003,
                                                    -9.112
                                                ],
                                                [
                                                    15.783,
                                                    -18.222
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            79.408,
                                            36.946
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 9
                }
            ]
        },
        {
            "nm": "Dots line",
            "id": "3",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 3",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31841",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                -89.865,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                389.657,
                                386.872
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.166,
                                                    -17.144
                                                ],
                                                [
                                                    -115.974,
                                                    -17.144
                                                ],
                                                [
                                                    -116.072,
                                                    -69.047
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 1
                                                        },
                                                        "s": [
                                                            94
                                                        ],
                                                        "t": 72.999
                                                    },
                                                    {
                                                        "s": [
                                                            500
                                                        ],
                                                        "t": 296.998
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 0,
                                "k": 100
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0,
                                            "y": 0
                                        },
                                        "i": {
                                            "x": 1,
                                            "y": 1
                                        },
                                        "s": [
                                            100
                                        ],
                                        "t": 0
                                    },
                                    {
                                        "s": [
                                            0
                                        ],
                                        "t": 69.999
                                    }
                                ]
                            },
                            "m": 1
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31840",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                386.667
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.166,
                                                    -17.144
                                                ],
                                                [
                                                    -115.974,
                                                    -17.144
                                                ],
                                                [
                                                    -116.072,
                                                    -69.047
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            0
                                                        ],
                                                        "t": 71.999
                                                    },
                                                    {
                                                        "s": [
                                                            500
                                                        ],
                                                        "t": 276.998
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 0,
                                "k": 100
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0,
                                            "y": 0
                                        },
                                        "i": {
                                            "x": 1,
                                            "y": 1
                                        },
                                        "s": [
                                            100
                                        ],
                                        "t": 0
                                    },
                                    {
                                        "s": [
                                            0
                                        ],
                                        "t": 74.999
                                    }
                                ]
                            },
                            "m": 1
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 61,
                    "op": 4900,
                    "ip": 61,
                    "ln": "31839",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                4.658,
                                43.894
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                63.09
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                386.658,
                                411.3
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.658,
                                                    121.014
                                                ],
                                                [
                                                    4.658,
                                                    -23.155
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "tm",
                                    "nm": "Trim Paths 1",
                                    "e": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 1
                                                },
                                                "s": [
                                                    93.099
                                                ],
                                                "t": 53.57
                                            },
                                            {
                                                "s": [
                                                    0
                                                ],
                                                "t": 123
                                            }
                                        ]
                                    },
                                    "m": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 25
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            184
                                                        ],
                                                        "t": 79
                                                    },
                                                    {
                                                        "s": [
                                                            600
                                                        ],
                                                        "t": 198.999
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            73
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            1
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Pre-comp 1",
            "id": "4",
            "fr": 60,
            "layers": [
                {
                    "ty": 5,
                    "nm": "You\xe2\x80\x99re on the Pro Plan \xe2\x80\x94 $49/month, 50,000 messages, 5 sites.",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31801",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                177.169,
                                247.91
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Medium",
                                        "s": 11,
                                        "t": "You\xe2\x80\x99re on the Pro Plan \xe2\x80\x94 $49/month,\r50,000 messages, 5 sites.",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 12,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31800",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -152.54,
                                -115.762
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                117.486,
                                117.486
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                240.563,
                                250.238
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            137.586,
                                            32.635
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9098,
                                            0.8784,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            109.4
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -152.54,
                                            -115.762
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "AI Chat icon.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 4840,
                    "ip": 0,
                    "ln": "31799",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                137,
                                257.284
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 34,
                    "h": 34,
                    "refId": "11",
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "AI Chat card Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31798",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                219,
                                54
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                56.016,
                                47.753
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                287.856,
                                248.835
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    21.719,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -21.718
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    21.719
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -21.718,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    21.719,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -21.718
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    178.7,
                                                    -53.325
                                                ],
                                                [
                                                    -178.701,
                                                    -53.325
                                                ],
                                                [
                                                    -218.025,
                                                    -14
                                                ],
                                                [
                                                    -218.025,
                                                    53.325
                                                ],
                                                [
                                                    178.7,
                                                    53.325
                                                ],
                                                [
                                                    218.025,
                                                    14
                                                ],
                                                [
                                                    218.025,
                                                    -14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.35
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8706,
                                            0.8275,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9098,
                                            0.8784,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            218.77,
                                            54.873
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "AI Chat icon.svg",
            "id": "11",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "AI Chat icon.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 4840,
                    "ip": 0,
                    "ln": "31783",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.111,
                                                    0.321
                                                ],
                                                [
                                                    0.288,
                                                    0.182
                                                ],
                                                [
                                                    0.338,
                                                    -0.038
                                                ],
                                                [
                                                    0.241,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    -0.291
                                                ],
                                                [
                                                    -0.113,
                                                    -0.274
                                                ],
                                                [
                                                    -0.247,
                                                    -0.165
                                                ],
                                                [
                                                    -0.297,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.071,
                                                    -0.037
                                                ],
                                                [
                                                    -0.046,
                                                    -0.065
                                                ],
                                                [
                                                    -0.011,
                                                    -0.079
                                                ],
                                                [
                                                    0.027,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.112,
                                                    -0.322
                                                ],
                                                [
                                                    -0.288,
                                                    -0.181
                                                ],
                                                [
                                                    -0.338,
                                                    0.038
                                                ],
                                                [
                                                    -0.24,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.058,
                                                    0.291
                                                ],
                                                [
                                                    0.114,
                                                    0.274
                                                ],
                                                [
                                                    0.247,
                                                    0.165
                                                ],
                                                [
                                                    0.297,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.071,
                                                    0.037
                                                ],
                                                [
                                                    0.046,
                                                    0.065
                                                ],
                                                [
                                                    0.011,
                                                    0.079
                                                ],
                                                [
                                                    -0.027,
                                                    0.075
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.113,
                                                    -0.321
                                                ],
                                                [
                                                    -0.112,
                                                    -0.322
                                                ],
                                                [
                                                    -0.288,
                                                    -0.181
                                                ],
                                                [
                                                    -0.338,
                                                    0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.21
                                                ],
                                                [
                                                    -0.058,
                                                    0.291
                                                ],
                                                [
                                                    0.114,
                                                    0.274
                                                ],
                                                [
                                                    0.246,
                                                    0.165
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    0
                                                ],
                                                [
                                                    0.07,
                                                    0.037
                                                ],
                                                [
                                                    0.046,
                                                    0.066
                                                ],
                                                [
                                                    0.011,
                                                    0.079
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.113,
                                                    0.321
                                                ],
                                                [
                                                    0.111,
                                                    0.321
                                                ],
                                                [
                                                    0.287,
                                                    0.182
                                                ],
                                                [
                                                    0.338,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.21
                                                ],
                                                [
                                                    0.058,
                                                    -0.291
                                                ],
                                                [
                                                    -0.113,
                                                    -0.274
                                                ],
                                                [
                                                    -0.246,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.08,
                                                    0
                                                ],
                                                [
                                                    -0.071,
                                                    -0.037
                                                ],
                                                [
                                                    -0.046,
                                                    -0.066
                                                ],
                                                [
                                                    -0.011,
                                                    -0.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.914,
                                                    -8
                                                ],
                                                [
                                                    3.917,
                                                    -8.991
                                                ],
                                                [
                                                    3.3,
                                                    -9.768
                                                ],
                                                [
                                                    2.334,
                                                    -9.99
                                                ],
                                                [
                                                    1.44,
                                                    -9.561
                                                ],
                                                [
                                                    -7.56,
                                                    -0.561
                                                ],
                                                [
                                                    -7.971,
                                                    0.207
                                                ],
                                                [
                                                    -7.886,
                                                    1.074
                                                ],
                                                [
                                                    -7.333,
                                                    1.747
                                                ],
                                                [
                                                    -6.5,
                                                    2
                                                ],
                                                [
                                                    -2.498,
                                                    2
                                                ],
                                                [
                                                    -2.268,
                                                    2.056
                                                ],
                                                [
                                                    -2.09,
                                                    2.211
                                                ],
                                                [
                                                    -2.003,
                                                    2.431
                                                ],
                                                [
                                                    -2.027,
                                                    2.666
                                                ],
                                                [
                                                    -3.914,
                                                    8
                                                ],
                                                [
                                                    -3.916,
                                                    8.992
                                                ],
                                                [
                                                    -3.299,
                                                    9.768
                                                ],
                                                [
                                                    -2.333,
                                                    9.99
                                                ],
                                                [
                                                    -1.439,
                                                    9.56
                                                ],
                                                [
                                                    7.561,
                                                    0.56
                                                ],
                                                [
                                                    7.971,
                                                    -0.208
                                                ],
                                                [
                                                    7.885,
                                                    -1.074
                                                ],
                                                [
                                                    7.333,
                                                    -1.747
                                                ],
                                                [
                                                    6.5,
                                                    -2
                                                ],
                                                [
                                                    2.503,
                                                    -2
                                                ],
                                                [
                                                    2.273,
                                                    -2.056
                                                ],
                                                [
                                                    2.094,
                                                    -2.211
                                                ],
                                                [
                                                    2.007,
                                                    -2.431
                                                ],
                                                [
                                                    2.031,
                                                    -2.667
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "gf",
                                    "nm": "Gradient Fill 1",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            12
                                        ]
                                    },
                                    "g": {
                                        "p": 3,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                0.51372552,
                                                0.36078432,
                                                0.96078438,
                                                0.5,
                                                0.2941176635,
                                                0.6588235649999999,
                                                0.729411815,
                                                1,
                                                0.074509807,
                                                0.95686281,
                                                0.49803925
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            -12
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            17,
                                            17
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.083
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -16.446
                                                ],
                                                [
                                                    0,
                                                    -16.446
                                                ],
                                                [
                                                    16.446,
                                                    0
                                                ],
                                                [
                                                    16.446,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    16.446
                                                ],
                                                [
                                                    0,
                                                    16.446
                                                ],
                                                [
                                                    -16.446,
                                                    0
                                                ],
                                                [
                                                    -16.446,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.109
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.5137,
                                            0.3608,
                                            0.9608
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.902,
                                            0.8706,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            17,
                                            17
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Webpage",
            "id": "12",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Webpage header.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 4840,
                    "ip": 0,
                    "ln": "31817",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                159.906
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 556,
                    "h": 63,
                    "refId": "13",
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "31816",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -64.742,
                                -113.483
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                317.258,
                                254.517
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            427.195,
                                            155.066
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            130.111,
                                            130.111
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -0.395,
                                            -137.752
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                }
            ]
        },
        {
            "nm": "Webpage header.svg",
            "id": "13",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Webpage header.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 4840,
                    "ip": 0,
                    "ln": "31768",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.584,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.664
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.311,
                                                    0.672
                                                ],
                                                [
                                                    -0.576,
                                                    0.36
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.36
                                                ],
                                                [
                                                    -0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.583,
                                                    -0.36
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.36
                                                ],
                                                [
                                                    -0.311,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.584,
                                                    -0.36
                                                ],
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.312,
                                                    0.664
                                                ],
                                                [
                                                    -0.577,
                                                    0.36
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    4.452
                                                ],
                                                [
                                                    -15.294,
                                                    3.912
                                                ],
                                                [
                                                    -16.626,
                                                    2.376
                                                ],
                                                [
                                                    -17.094,
                                                    0.012
                                                ],
                                                [
                                                    -16.626,
                                                    -2.364
                                                ],
                                                [
                                                    -15.294,
                                                    -3.912
                                                ],
                                                [
                                                    -13.242,
                                                    -4.452
                                                ],
                                                [
                                                    -11.201,
                                                    -3.912
                                                ],
                                                [
                                                    -9.858,
                                                    -2.364
                                                ],
                                                [
                                                    -9.39,
                                                    0.012
                                                ],
                                                [
                                                    -9.858,
                                                    2.376
                                                ],
                                                [
                                                    -11.201,
                                                    3.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.264
                                                ],
                                                [
                                                    -0.216,
                                                    0.512
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.52
                                                ],
                                                [
                                                    0.416,
                                                    0.272
                                                ],
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ],
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.272
                                                ],
                                                [
                                                    -0.216,
                                                    0.52
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.512
                                                ],
                                                [
                                                    0.416,
                                                    0.264
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    3.468
                                                ],
                                                [
                                                    -11.718,
                                                    3.072
                                                ],
                                                [
                                                    -10.77,
                                                    1.896
                                                ],
                                                [
                                                    -10.446,
                                                    0.012
                                                ],
                                                [
                                                    -10.77,
                                                    -1.872
                                                ],
                                                [
                                                    -11.718,
                                                    -3.06
                                                ],
                                                [
                                                    -13.242,
                                                    -3.468
                                                ],
                                                [
                                                    -14.766,
                                                    -3.06
                                                ],
                                                [
                                                    -15.714,
                                                    -1.872
                                                ],
                                                [
                                                    -16.038,
                                                    0.012
                                                ],
                                                [
                                                    -15.714,
                                                    1.896
                                                ],
                                                [
                                                    -14.766,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.113,
                                                    -2.1
                                                ],
                                                [
                                                    -7.065,
                                                    -0.468
                                                ],
                                                [
                                                    -7.197,
                                                    -0.6
                                                ],
                                                [
                                                    -6.477,
                                                    -1.824
                                                ],
                                                [
                                                    -5.121,
                                                    -2.244
                                                ],
                                                [
                                                    -3.525,
                                                    -1.572
                                                ],
                                                [
                                                    -2.973,
                                                    0.168
                                                ],
                                                [
                                                    -2.973,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    0.456
                                                ],
                                                [
                                                    -4.101,
                                                    -0.54
                                                ],
                                                [
                                                    -4.545,
                                                    -1.152
                                                ],
                                                [
                                                    -5.325,
                                                    -1.368
                                                ],
                                                [
                                                    -6.573,
                                                    -0.888
                                                ],
                                                [
                                                    -7.029,
                                                    0.456
                                                ],
                                                [
                                                    -7.029,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.064
                                                ],
                                                [
                                                    -0.136,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.232,
                                                    0.224
                                                ],
                                                [
                                                    0,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    0.072,
                                                    0.064
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    -0.232
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.161,
                                                    -4.26
                                                ],
                                                [
                                                    -0.161,
                                                    2.988
                                                ],
                                                [
                                                    -0.065,
                                                    3.288
                                                ],
                                                [
                                                    0.247,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    4.26
                                                ],
                                                [
                                                    0.103,
                                                    4.26
                                                ],
                                                [
                                                    -0.809,
                                                    3.924
                                                ],
                                                [
                                                    -1.145,
                                                    3.036
                                                ],
                                                [
                                                    -1.145,
                                                    -4.26
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.178,
                                                    -2.1
                                                ],
                                                [
                                                    3.178,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.202,
                                                    -4.236
                                                ],
                                                [
                                                    3.202,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -4.236
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.941,
                                                    -2.1
                                                ],
                                                [
                                                    5.989,
                                                    -0.468
                                                ],
                                                [
                                                    5.857,
                                                    -0.6
                                                ],
                                                [
                                                    6.577,
                                                    -1.824
                                                ],
                                                [
                                                    7.933,
                                                    -2.244
                                                ],
                                                [
                                                    9.529,
                                                    -1.572
                                                ],
                                                [
                                                    10.081,
                                                    0.168
                                                ],
                                                [
                                                    10.081,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    0.456
                                                ],
                                                [
                                                    8.953,
                                                    -0.54
                                                ],
                                                [
                                                    8.509,
                                                    -1.152
                                                ],
                                                [
                                                    7.729,
                                                    -1.368
                                                ],
                                                [
                                                    6.481,
                                                    -0.888
                                                ],
                                                [
                                                    6.025,
                                                    0.456
                                                ],
                                                [
                                                    6.025,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.672
                                                ],
                                                [
                                                    -0.24,
                                                    0.496
                                                ],
                                                [
                                                    -0.431,
                                                    0.272
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.4,
                                                    -0.224
                                                ],
                                                [
                                                    -0.248,
                                                    -0.48
                                                ],
                                                [
                                                    -0.032,
                                                    -0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -0.368
                                                ],
                                                [
                                                    -0.544,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.192
                                                ],
                                                [
                                                    -0.144,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.352
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.44,
                                                    0.272
                                                ],
                                                [
                                                    0.24,
                                                    0.496
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.672
                                                ],
                                                [
                                                    0.24,
                                                    -0.504
                                                ],
                                                [
                                                    0.44,
                                                    -0.272
                                                ],
                                                [
                                                    0.496,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    0.224
                                                ],
                                                [
                                                    0.256,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    0.656
                                                ],
                                                [
                                                    0.328,
                                                    0.36
                                                ],
                                                [
                                                    0.353,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.184,
                                                    0.592
                                                ],
                                                [
                                                    -0.488,
                                                    0.352
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.431,
                                                    -0.272
                                                ],
                                                [
                                                    -0.24,
                                                    -0.504
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.417,
                                                    1.08
                                                ],
                                                [
                                                    11.777,
                                                    -0.672
                                                ],
                                                [
                                                    12.785,
                                                    -1.836
                                                ],
                                                [
                                                    14.321,
                                                    -2.244
                                                ],
                                                [
                                                    15.665,
                                                    -1.908
                                                ],
                                                [
                                                    16.649,
                                                    -0.852
                                                ],
                                                [
                                                    17.081,
                                                    0.948
                                                ],
                                                [
                                                    17.093,
                                                    1.392
                                                ],
                                                [
                                                    12.461,
                                                    1.392
                                                ],
                                                [
                                                    13.013,
                                                    2.928
                                                ],
                                                [
                                                    14.321,
                                                    3.468
                                                ],
                                                [
                                                    15.281,
                                                    3.18
                                                ],
                                                [
                                                    15.929,
                                                    2.388
                                                ],
                                                [
                                                    16.985,
                                                    2.46
                                                ],
                                                [
                                                    15.977,
                                                    3.876
                                                ],
                                                [
                                                    14.321,
                                                    4.404
                                                ],
                                                [
                                                    12.785,
                                                    3.996
                                                ],
                                                [
                                                    11.777,
                                                    2.844
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    0.288
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.32
                                                ],
                                                [
                                                    0.088,
                                                    -0.584
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.088,
                                                    -0.632
                                                ],
                                                [
                                                    -0.304,
                                                    -0.296
                                                ],
                                                [
                                                    -0.512,
                                                    0
                                                ],
                                                [
                                                    -0.312,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.013,
                                                    0.516
                                                ],
                                                [
                                                    15.425,
                                                    -0.864
                                                ],
                                                [
                                                    14.321,
                                                    -1.308
                                                ],
                                                [
                                                    13.085,
                                                    -0.828
                                                ],
                                                [
                                                    12.485,
                                                    0.516
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9333,
                                            0.9255,
                                            0.9255
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            94.682,
                                            43.24
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ],
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ],
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -4.5
                                                ],
                                                [
                                                    4.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.5
                                                ],
                                                [
                                                    -4.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.1216,
                                            0.7569,
                                            0.4196
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            64.5,
                                            43.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.811,
                                                    0.512
                                                ],
                                                [
                                                    0.437,
                                                    0.896
                                                ],
                                                [
                                                    0,
                                                    1.12
                                                ],
                                                [
                                                    -0.427,
                                                    0.907
                                                ],
                                                [
                                                    -0.811,
                                                    0.512
                                                ],
                                                [
                                                    -1.077,
                                                    0
                                                ],
                                                [
                                                    -0.811,
                                                    -0.523
                                                ],
                                                [
                                                    -0.427,
                                                    -0.907
                                                ],
                                                [
                                                    0,
                                                    -1.12
                                                ],
                                                [
                                                    0.373,
                                                    -0.853
                                                ],
                                                [
                                                    0.672,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.077,
                                                    0
                                                ],
                                                [
                                                    -0.8,
                                                    -0.523
                                                ],
                                                [
                                                    -0.437,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    -1.12
                                                ],
                                                [
                                                    0.437,
                                                    -0.907
                                                ],
                                                [
                                                    0.811,
                                                    -0.523
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.811,
                                                    0.512
                                                ],
                                                [
                                                    0.427,
                                                    0.907
                                                ],
                                                [
                                                    0,
                                                    1.024
                                                ],
                                                [
                                                    -0.363,
                                                    0.843
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.64,
                                                    0.245
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.291,
                                                    5.544
                                                ],
                                                [
                                                    -48.123,
                                                    4.776
                                                ],
                                                [
                                                    -49.979,
                                                    2.648
                                                ],
                                                [
                                                    -50.635,
                                                    -0.376
                                                ],
                                                [
                                                    -49.995,
                                                    -3.416
                                                ],
                                                [
                                                    -48.123,
                                                    -5.544
                                                ],
                                                [
                                                    -45.291,
                                                    -6.328
                                                ],
                                                [
                                                    -42.443,
                                                    -5.544
                                                ],
                                                [
                                                    -40.587,
                                                    -3.416
                                                ],
                                                [
                                                    -39.947,
                                                    -0.376
                                                ],
                                                [
                                                    -40.507,
                                                    2.44
                                                ],
                                                [
                                                    -42.059,
                                                    4.488
                                                ],
                                                [
                                                    -40.603,
                                                    6.328
                                                ],
                                                [
                                                    -42.331,
                                                    6.328
                                                ],
                                                [
                                                    -43.227,
                                                    5.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    -0.245,
                                                    -0.629
                                                ],
                                                [
                                                    -0.491,
                                                    -0.373
                                                ],
                                                [
                                                    -0.704,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0.693
                                                ],
                                                [
                                                    0.245,
                                                    0.619
                                                ],
                                                [
                                                    0.491,
                                                    0.373
                                                ],
                                                [
                                                    0.725,
                                                    0
                                                ],
                                                [
                                                    0.491,
                                                    -0.384
                                                ],
                                                [
                                                    0.245,
                                                    -0.629
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.768
                                                ],
                                                [
                                                    0.245,
                                                    0.619
                                                ],
                                                [
                                                    0.491,
                                                    0.373
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.373
                                                ],
                                                [
                                                    0.213,
                                                    -0.587
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    -0.235,
                                                    -0.629
                                                ],
                                                [
                                                    -0.48,
                                                    -0.384
                                                ],
                                                [
                                                    -0.715,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0.373
                                                ],
                                                [
                                                    -0.245,
                                                    0.619
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -48.555,
                                                    -0.376
                                                ],
                                                [
                                                    -48.187,
                                                    1.72
                                                ],
                                                [
                                                    -47.083,
                                                    3.208
                                                ],
                                                [
                                                    -45.291,
                                                    3.768
                                                ],
                                                [
                                                    -44.443,
                                                    3.656
                                                ],
                                                [
                                                    -46.011,
                                                    1.656
                                                ],
                                                [
                                                    -44.283,
                                                    1.656
                                                ],
                                                [
                                                    -43.275,
                                                    2.968
                                                ],
                                                [
                                                    -42.347,
                                                    1.544
                                                ],
                                                [
                                                    -42.027,
                                                    -0.376
                                                ],
                                                [
                                                    -42.395,
                                                    -2.472
                                                ],
                                                [
                                                    -43.483,
                                                    -3.976
                                                ],
                                                [
                                                    -45.291,
                                                    -4.552
                                                ],
                                                [
                                                    -47.099,
                                                    -3.976
                                                ],
                                                [
                                                    -48.187,
                                                    -2.472
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.491,
                                                    -0.384
                                                ],
                                                [
                                                    0.704,
                                                    0
                                                ],
                                                [
                                                    0.502,
                                                    0.587
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    -0.32
                                                ],
                                                [
                                                    -0.202,
                                                    -0.171
                                                ],
                                                [
                                                    -0.362,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.138,
                                                    0.811
                                                ],
                                                [
                                                    -0.49,
                                                    0.373
                                                ],
                                                [
                                                    -0.906,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.587
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.512
                                                ],
                                                [
                                                    0.107,
                                                    0.32
                                                ],
                                                [
                                                    0.214,
                                                    0.16
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -32.526,
                                                    5.288
                                                ],
                                                [
                                                    -32.574,
                                                    2.984
                                                ],
                                                [
                                                    -32.318,
                                                    3.128
                                                ],
                                                [
                                                    -33.262,
                                                    4.92
                                                ],
                                                [
                                                    -35.054,
                                                    5.48
                                                ],
                                                [
                                                    -37.166,
                                                    4.6
                                                ],
                                                [
                                                    -37.918,
                                                    2.264
                                                ],
                                                [
                                                    -37.918,
                                                    -3.192
                                                ],
                                                [
                                                    -35.934,
                                                    -3.192
                                                ],
                                                [
                                                    -35.934,
                                                    1.624
                                                ],
                                                [
                                                    -35.79,
                                                    2.872
                                                ],
                                                [
                                                    -35.326,
                                                    3.608
                                                ],
                                                [
                                                    -34.462,
                                                    3.848
                                                ],
                                                [
                                                    -33.15,
                                                    3.288
                                                ],
                                                [
                                                    -32.67,
                                                    1.624
                                                ],
                                                [
                                                    -32.67,
                                                    -3.192
                                                ],
                                                [
                                                    -30.686,
                                                    -3.192
                                                ],
                                                [
                                                    -30.686,
                                                    5.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.832,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    0.363
                                                ],
                                                [
                                                    0.352,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    -0.341,
                                                    0.661
                                                ],
                                                [
                                                    -0.618,
                                                    0.363
                                                ],
                                                [
                                                    -0.832,
                                                    0
                                                ],
                                                [
                                                    -0.629,
                                                    -0.363
                                                ],
                                                [
                                                    -0.341,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.342,
                                                    -0.672
                                                ],
                                                [
                                                    0.63,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.832,
                                                    0
                                                ],
                                                [
                                                    -0.618,
                                                    -0.363
                                                ],
                                                [
                                                    -0.341,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.352,
                                                    -0.672
                                                ],
                                                [
                                                    0.63,
                                                    -0.363
                                                ],
                                                [
                                                    0.832,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    0.363
                                                ],
                                                [
                                                    0.342,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    -0.341,
                                                    0.672
                                                ],
                                                [
                                                    -0.629,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.648,
                                                    5.48
                                                ],
                                                [
                                                    -26.84,
                                                    4.936
                                                ],
                                                [
                                                    -28.296,
                                                    3.384
                                                ],
                                                [
                                                    -28.808,
                                                    1.048
                                                ],
                                                [
                                                    -28.296,
                                                    -1.288
                                                ],
                                                [
                                                    -26.84,
                                                    -2.84
                                                ],
                                                [
                                                    -24.648,
                                                    -3.384
                                                ],
                                                [
                                                    -22.456,
                                                    -2.84
                                                ],
                                                [
                                                    -21,
                                                    -1.288
                                                ],
                                                [
                                                    -20.488,
                                                    1.048
                                                ],
                                                [
                                                    -21,
                                                    3.384
                                                ],
                                                [
                                                    -22.456,
                                                    4.936
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    0.363,
                                                    0.491
                                                ],
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.374,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.885
                                                ],
                                                [
                                                    -0.362,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.885
                                                ],
                                                [
                                                    -0.362,
                                                    -0.491
                                                ],
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    0.374,
                                                    0.491
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.648,
                                                    3.848
                                                ],
                                                [
                                                    -23.08,
                                                    3.112
                                                ],
                                                [
                                                    -22.536,
                                                    1.048
                                                ],
                                                [
                                                    -23.08,
                                                    -1.016
                                                ],
                                                [
                                                    -24.648,
                                                    -1.752
                                                ],
                                                [
                                                    -26.216,
                                                    -1.016
                                                ],
                                                [
                                                    -26.76,
                                                    1.048
                                                ],
                                                [
                                                    -26.216,
                                                    3.112
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -16.749,
                                                    -6.072
                                                ],
                                                [
                                                    -16.749,
                                                    0.696
                                                ],
                                                [
                                                    -13.245,
                                                    -3.192
                                                ],
                                                [
                                                    -10.781,
                                                    -3.192
                                                ],
                                                [
                                                    -14.093,
                                                    0.328
                                                ],
                                                [
                                                    -10.637,
                                                    5.288
                                                ],
                                                [
                                                    -12.877,
                                                    5.288
                                                ],
                                                [
                                                    -15.389,
                                                    1.528
                                                ],
                                                [
                                                    -16.749,
                                                    3
                                                ],
                                                [
                                                    -16.749,
                                                    5.288
                                                ],
                                                [
                                                    -18.733,
                                                    5.288
                                                ],
                                                [
                                                    -18.733,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.702,
                                                    -6.072
                                                ],
                                                [
                                                    -6.702,
                                                    0.696
                                                ],
                                                [
                                                    -3.198,
                                                    -3.192
                                                ],
                                                [
                                                    -0.734,
                                                    -3.192
                                                ],
                                                [
                                                    -4.046,
                                                    0.328
                                                ],
                                                [
                                                    -0.59,
                                                    5.288
                                                ],
                                                [
                                                    -2.83,
                                                    5.288
                                                ],
                                                [
                                                    -5.342,
                                                    1.528
                                                ],
                                                [
                                                    -6.702,
                                                    3
                                                ],
                                                [
                                                    -6.702,
                                                    5.288
                                                ],
                                                [
                                                    -8.686,
                                                    5.288
                                                ],
                                                [
                                                    -8.686,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.096
                                                ],
                                                [
                                                    -0.171,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    0.053
                                                ],
                                                [
                                                    0.224,
                                                    0.192
                                                ],
                                                [
                                                    0.032,
                                                    0.395
                                                ],
                                                [
                                                    0.48,
                                                    -0.277
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.246,
                                                    0.331
                                                ],
                                                [
                                                    -0.448,
                                                    0.192
                                                ],
                                                [
                                                    -0.736,
                                                    0.139
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.277,
                                                    0.309
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.245
                                                ],
                                                [
                                                    0.106,
                                                    -0.459
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.17,
                                                    -0.875
                                                ],
                                                [
                                                    0.65,
                                                    -0.491
                                                ],
                                                [
                                                    1.216,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.096,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.011
                                                ],
                                                [
                                                    -0.288,
                                                    -0.053
                                                ],
                                                [
                                                    -0.224,
                                                    -0.192
                                                ],
                                                [
                                                    -0.214,
                                                    0.437
                                                ],
                                                [
                                                    -0.48,
                                                    0.277
                                                ],
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.256,
                                                    -0.331
                                                ],
                                                [
                                                    0.458,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    -0.651
                                                ],
                                                [
                                                    -0.278,
                                                    -0.32
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.821,
                                                    -0.616
                                                ],
                                                [
                                                    2.053,
                                                    -2.648
                                                ],
                                                [
                                                    4.565,
                                                    -3.384
                                                ],
                                                [
                                                    7.333,
                                                    -2.456
                                                ],
                                                [
                                                    8.277,
                                                    0.248
                                                ],
                                                [
                                                    8.277,
                                                    3.208
                                                ],
                                                [
                                                    8.405,
                                                    3.688
                                                ],
                                                [
                                                    8.805,
                                                    3.816
                                                ],
                                                [
                                                    9.125,
                                                    3.816
                                                ],
                                                [
                                                    9.125,
                                                    5.288
                                                ],
                                                [
                                                    8.629,
                                                    5.304
                                                ],
                                                [
                                                    8.565,
                                                    5.304
                                                ],
                                                [
                                                    7.685,
                                                    5.24
                                                ],
                                                [
                                                    6.917,
                                                    4.872
                                                ],
                                                [
                                                    6.533,
                                                    3.992
                                                ],
                                                [
                                                    5.493,
                                                    5.064
                                                ],
                                                [
                                                    3.733,
                                                    5.48
                                                ],
                                                [
                                                    1.541,
                                                    4.824
                                                ],
                                                [
                                                    0.677,
                                                    3.064
                                                ],
                                                [
                                                    1.045,
                                                    1.768
                                                ],
                                                [
                                                    2.101,
                                                    0.984
                                                ],
                                                [
                                                    3.893,
                                                    0.488
                                                ],
                                                [
                                                    6.277,
                                                    0.008
                                                ],
                                                [
                                                    5.845,
                                                    -1.432
                                                ],
                                                [
                                                    4.565,
                                                    -1.912
                                                ],
                                                [
                                                    3.445,
                                                    -1.544
                                                ],
                                                [
                                                    2.853,
                                                    -0.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.288
                                                ],
                                                [
                                                    -0.256,
                                                    -0.203
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.192
                                                ],
                                                [
                                                    -0.171,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.075
                                                ],
                                                [
                                                    0.138,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.309
                                                ],
                                                [
                                                    0.266,
                                                    0.192
                                                ],
                                                [
                                                    0.394,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0.181,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.075
                                                ],
                                                [
                                                    -0.214,
                                                    0.075
                                                ],
                                                [
                                                    -0.139,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.725,
                                                    3
                                                ],
                                                [
                                                    3.109,
                                                    3.768
                                                ],
                                                [
                                                    4.245,
                                                    4.056
                                                ],
                                                [
                                                    5.301,
                                                    3.768
                                                ],
                                                [
                                                    6.037,
                                                    2.904
                                                ],
                                                [
                                                    6.309,
                                                    1.48
                                                ],
                                                [
                                                    6.309,
                                                    1.4
                                                ],
                                                [
                                                    4.677,
                                                    1.688
                                                ],
                                                [
                                                    4.389,
                                                    1.736
                                                ],
                                                [
                                                    3.461,
                                                    1.96
                                                ],
                                                [
                                                    2.933,
                                                    2.328
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    14.739,
                                                    -6.072
                                                ],
                                                [
                                                    16.755,
                                                    -6.072
                                                ],
                                                [
                                                    16.755,
                                                    4.632
                                                ],
                                                [
                                                    15.651,
                                                    3.512
                                                ],
                                                [
                                                    22.163,
                                                    3.512
                                                ],
                                                [
                                                    22.163,
                                                    5.288
                                                ],
                                                [
                                                    14.739,
                                                    5.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.096
                                                ],
                                                [
                                                    -0.171,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    0.053
                                                ],
                                                [
                                                    0.224,
                                                    0.192
                                                ],
                                                [
                                                    0.032,
                                                    0.395
                                                ],
                                                [
                                                    0.48,
                                                    -0.277
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.246,
                                                    0.331
                                                ],
                                                [
                                                    -0.448,
                                                    0.192
                                                ],
                                                [
                                                    -0.736,
                                                    0.139
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.277,
                                                    0.309
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.245
                                                ],
                                                [
                                                    0.106,
                                                    -0.459
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.17,
                                                    -0.875
                                                ],
                                                [
                                                    0.65,
                                                    -0.491
                                                ],
                                                [
                                                    1.216,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.096,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.011
                                                ],
                                                [
                                                    -0.288,
                                                    -0.053
                                                ],
                                                [
                                                    -0.224,
                                                    -0.192
                                                ],
                                                [
                                                    -0.214,
                                                    0.437
                                                ],
                                                [
                                                    -0.48,
                                                    0.277
                                                ],
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.256,
                                                    -0.331
                                                ],
                                                [
                                                    0.458,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    -0.651
                                                ],
                                                [
                                                    -0.278,
                                                    -0.32
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.618,
                                                    -0.616
                                                ],
                                                [
                                                    24.85,
                                                    -2.648
                                                ],
                                                [
                                                    27.362,
                                                    -3.384
                                                ],
                                                [
                                                    30.13,
                                                    -2.456
                                                ],
                                                [
                                                    31.074,
                                                    0.248
                                                ],
                                                [
                                                    31.074,
                                                    3.208
                                                ],
                                                [
                                                    31.202,
                                                    3.688
                                                ],
                                                [
                                                    31.602,
                                                    3.816
                                                ],
                                                [
                                                    31.922,
                                                    3.816
                                                ],
                                                [
                                                    31.922,
                                                    5.288
                                                ],
                                                [
                                                    31.426,
                                                    5.304
                                                ],
                                                [
                                                    31.362,
                                                    5.304
                                                ],
                                                [
                                                    30.482,
                                                    5.24
                                                ],
                                                [
                                                    29.714,
                                                    4.872
                                                ],
                                                [
                                                    29.33,
                                                    3.992
                                                ],
                                                [
                                                    28.29,
                                                    5.064
                                                ],
                                                [
                                                    26.53,
                                                    5.48
                                                ],
                                                [
                                                    24.338,
                                                    4.824
                                                ],
                                                [
                                                    23.474,
                                                    3.064
                                                ],
                                                [
                                                    23.842,
                                                    1.768
                                                ],
                                                [
                                                    24.898,
                                                    0.984
                                                ],
                                                [
                                                    26.69,
                                                    0.488
                                                ],
                                                [
                                                    29.074,
                                                    0.008
                                                ],
                                                [
                                                    28.642,
                                                    -1.432
                                                ],
                                                [
                                                    27.362,
                                                    -1.912
                                                ],
                                                [
                                                    26.242,
                                                    -1.544
                                                ],
                                                [
                                                    25.65,
                                                    -0.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.288
                                                ],
                                                [
                                                    -0.256,
                                                    -0.203
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.192
                                                ],
                                                [
                                                    -0.171,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.075
                                                ],
                                                [
                                                    0.138,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.309
                                                ],
                                                [
                                                    0.266,
                                                    0.192
                                                ],
                                                [
                                                    0.394,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0.181,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.075
                                                ],
                                                [
                                                    -0.214,
                                                    0.075
                                                ],
                                                [
                                                    -0.139,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.522,
                                                    3
                                                ],
                                                [
                                                    25.906,
                                                    3.768
                                                ],
                                                [
                                                    27.042,
                                                    4.056
                                                ],
                                                [
                                                    28.098,
                                                    3.768
                                                ],
                                                [
                                                    28.834,
                                                    2.904
                                                ],
                                                [
                                                    29.106,
                                                    1.48
                                                ],
                                                [
                                                    29.106,
                                                    1.4
                                                ],
                                                [
                                                    27.474,
                                                    1.688
                                                ],
                                                [
                                                    27.186,
                                                    1.736
                                                ],
                                                [
                                                    26.258,
                                                    1.96
                                                ],
                                                [
                                                    25.73,
                                                    2.328
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.224
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.395
                                                ],
                                                [
                                                    -0.267,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    0.267,
                                                    -0.672
                                                ],
                                                [
                                                    0.544,
                                                    -0.395
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    0.235
                                                ],
                                                [
                                                    0.245,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.256,
                                                    -0.437
                                                ],
                                                [
                                                    0.427,
                                                    -0.224
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.395
                                                ],
                                                [
                                                    0.267,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    -0.267,
                                                    0.672
                                                ],
                                                [
                                                    -0.533,
                                                    0.395
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    -0.245
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.595,
                                                    -6.072
                                                ],
                                                [
                                                    35.595,
                                                    -2.056
                                                ],
                                                [
                                                    36.619,
                                                    -3.048
                                                ],
                                                [
                                                    38.139,
                                                    -3.384
                                                ],
                                                [
                                                    40.107,
                                                    -2.792
                                                ],
                                                [
                                                    41.323,
                                                    -1.192
                                                ],
                                                [
                                                    41.723,
                                                    1.048
                                                ],
                                                [
                                                    41.323,
                                                    3.288
                                                ],
                                                [
                                                    40.107,
                                                    4.888
                                                ],
                                                [
                                                    38.139,
                                                    5.48
                                                ],
                                                [
                                                    36.555,
                                                    5.128
                                                ],
                                                [
                                                    35.531,
                                                    4.088
                                                ],
                                                [
                                                    35.483,
                                                    5.288
                                                ],
                                                [
                                                    33.611,
                                                    5.288
                                                ],
                                                [
                                                    33.611,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    -0.149,
                                                    -0.427
                                                ],
                                                [
                                                    -0.309,
                                                    -0.256
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.533
                                                ],
                                                [
                                                    0,
                                                    0.789
                                                ],
                                                [
                                                    0.352,
                                                    0.544
                                                ],
                                                [
                                                    0.704,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.267
                                                ],
                                                [
                                                    0.149,
                                                    -0.427
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.501
                                                ],
                                                [
                                                    0.149,
                                                    0.427
                                                ],
                                                [
                                                    0.32,
                                                    0.256
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.544
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.352,
                                                    -0.544
                                                ],
                                                [
                                                    -0.469,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.256
                                                ],
                                                [
                                                    -0.149,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.467,
                                                    1.048
                                                ],
                                                [
                                                    35.691,
                                                    2.44
                                                ],
                                                [
                                                    36.379,
                                                    3.464
                                                ],
                                                [
                                                    37.579,
                                                    3.848
                                                ],
                                                [
                                                    39.147,
                                                    3.048
                                                ],
                                                [
                                                    39.691,
                                                    1.048
                                                ],
                                                [
                                                    39.163,
                                                    -1
                                                ],
                                                [
                                                    37.579,
                                                    -1.816
                                                ],
                                                [
                                                    36.395,
                                                    -1.416
                                                ],
                                                [
                                                    35.691,
                                                    -0.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    0.245
                                                ],
                                                [
                                                    0.416,
                                                    0
                                                ],
                                                [
                                                    0.278,
                                                    -0.203
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.32,
                                                    -0.181
                                                ],
                                                [
                                                    -0.512,
                                                    -0.096
                                                ],
                                                [
                                                    -0.512,
                                                    -0.203
                                                ],
                                                [
                                                    -0.266,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.32,
                                                    -0.363
                                                ],
                                                [
                                                    0.544,
                                                    -0.181
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.235
                                                ],
                                                [
                                                    0.342,
                                                    0.427
                                                ],
                                                [
                                                    0.054,
                                                    0.587
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.16,
                                                    -0.213
                                                ],
                                                [
                                                    -0.266,
                                                    -0.117
                                                ],
                                                [
                                                    -0.362,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.139,
                                                    0.139
                                                ],
                                                [
                                                    0.203,
                                                    0.064
                                                ],
                                                [
                                                    0.342,
                                                    0.075
                                                ],
                                                [
                                                    0.15,
                                                    0.043
                                                ],
                                                [
                                                    0.48,
                                                    0.181
                                                ],
                                                [
                                                    0.288,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.512
                                                ],
                                                [
                                                    -0.288,
                                                    0.405
                                                ],
                                                [
                                                    -0.533,
                                                    0.213
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.65,
                                                    -0.512
                                                ],
                                                [
                                                    -0.138,
                                                    -0.864
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.085,
                                                    -0.427
                                                ],
                                                [
                                                    -0.33,
                                                    -0.245
                                                ],
                                                [
                                                    -0.416,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    0.203
                                                ],
                                                [
                                                    0.011,
                                                    0.331
                                                ],
                                                [
                                                    0.32,
                                                    0.171
                                                ],
                                                [
                                                    0.811,
                                                    0.139
                                                ],
                                                [
                                                    0.512,
                                                    0.192
                                                ],
                                                [
                                                    0.278,
                                                    0.341
                                                ],
                                                [
                                                    0,
                                                    0.544
                                                ],
                                                [
                                                    -0.32,
                                                    0.363
                                                ],
                                                [
                                                    -0.533,
                                                    0.181
                                                ],
                                                [
                                                    -0.757,
                                                    0
                                                ],
                                                [
                                                    -0.586,
                                                    -0.235
                                                ],
                                                [
                                                    -0.33,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.309
                                                ],
                                                [
                                                    0.171,
                                                    0.213
                                                ],
                                                [
                                                    0.267,
                                                    0.117
                                                ],
                                                [
                                                    0.416,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.128,
                                                    -0.139
                                                ],
                                                [
                                                    -0.192,
                                                    -0.075
                                                ],
                                                [
                                                    -0.085,
                                                    -0.011
                                                ],
                                                [
                                                    -0.778,
                                                    -0.16
                                                ],
                                                [
                                                    -0.48,
                                                    -0.181
                                                ],
                                                [
                                                    -0.277,
                                                    -0.331
                                                ],
                                                [
                                                    0,
                                                    -0.544
                                                ],
                                                [
                                                    0.299,
                                                    -0.405
                                                ],
                                                [
                                                    0.544,
                                                    -0.224
                                                ],
                                                [
                                                    0.982,
                                                    0
                                                ],
                                                [
                                                    0.662,
                                                    0.501
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    48.523,
                                                    -0.488
                                                ],
                                                [
                                                    47.883,
                                                    -1.496
                                                ],
                                                [
                                                    46.763,
                                                    -1.864
                                                ],
                                                [
                                                    45.723,
                                                    -1.56
                                                ],
                                                [
                                                    45.323,
                                                    -0.76
                                                ],
                                                [
                                                    45.819,
                                                    0.008
                                                ],
                                                [
                                                    47.067,
                                                    0.408
                                                ],
                                                [
                                                    49.051,
                                                    0.92
                                                ],
                                                [
                                                    50.219,
                                                    1.72
                                                ],
                                                [
                                                    50.635,
                                                    3.032
                                                ],
                                                [
                                                    50.155,
                                                    4.392
                                                ],
                                                [
                                                    48.859,
                                                    5.208
                                                ],
                                                [
                                                    47.051,
                                                    5.48
                                                ],
                                                [
                                                    45.035,
                                                    5.128
                                                ],
                                                [
                                                    43.643,
                                                    4.136
                                                ],
                                                [
                                                    43.067,
                                                    2.6
                                                ],
                                                [
                                                    45.099,
                                                    2.488
                                                ],
                                                [
                                                    45.419,
                                                    3.272
                                                ],
                                                [
                                                    46.075,
                                                    3.768
                                                ],
                                                [
                                                    47.019,
                                                    3.944
                                                ],
                                                [
                                                    48.107,
                                                    3.704
                                                ],
                                                [
                                                    48.587,
                                                    2.968
                                                ],
                                                [
                                                    48.379,
                                                    2.424
                                                ],
                                                [
                                                    47.883,
                                                    2.12
                                                ],
                                                [
                                                    47.083,
                                                    1.896
                                                ],
                                                [
                                                    46.731,
                                                    1.816
                                                ],
                                                [
                                                    44.843,
                                                    1.304
                                                ],
                                                [
                                                    43.691,
                                                    0.552
                                                ],
                                                [
                                                    43.275,
                                                    -0.712
                                                ],
                                                [
                                                    43.707,
                                                    -2.136
                                                ],
                                                [
                                                    44.955,
                                                    -3.064
                                                ],
                                                [
                                                    46.875,
                                                    -3.4
                                                ],
                                                [
                                                    49.323,
                                                    -2.632
                                                ],
                                                [
                                                    50.523,
                                                    -0.584
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9216,
                                            0.9216,
                                            0.9216
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            111.339,
                                            23.212
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.359
                                                ],
                                                [
                                                    0.321,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0.269,
                                                    -0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.307
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.08,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.089
                                                ],
                                                [
                                                    0.029,
                                                    -0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.125,
                                                    -0.359
                                                ],
                                                [
                                                    -0.322,
                                                    -0.202
                                                ],
                                                [
                                                    -0.378,
                                                    0.042
                                                ],
                                                [
                                                    -0.269,
                                                    0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.065,
                                                    0.326
                                                ],
                                                [
                                                    0.127,
                                                    0.306
                                                ],
                                                [
                                                    0.275,
                                                    0.184
                                                ],
                                                [
                                                    0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.089
                                                ],
                                                [
                                                    -0.03,
                                                    0.085
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.127,
                                                    -0.359
                                                ],
                                                [
                                                    -0.125,
                                                    -0.359
                                                ],
                                                [
                                                    -0.321,
                                                    -0.203
                                                ],
                                                [
                                                    -0.377,
                                                    0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.234
                                                ],
                                                [
                                                    -0.064,
                                                    0.325
                                                ],
                                                [
                                                    0.126,
                                                    0.306
                                                ],
                                                [
                                                    0.276,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0
                                                ],
                                                [
                                                    0.079,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.126,
                                                    0.359
                                                ],
                                                [
                                                    0.125,
                                                    0.36
                                                ],
                                                [
                                                    0.321,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.234,
                                                    -0.235
                                                ],
                                                [
                                                    0.064,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.306
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    0
                                                ],
                                                [
                                                    -0.079,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.374,
                                                    -8.941
                                                ],
                                                [
                                                    4.377,
                                                    -10.049
                                                ],
                                                [
                                                    3.688,
                                                    -10.917
                                                ],
                                                [
                                                    2.608,
                                                    -11.165
                                                ],
                                                [
                                                    1.609,
                                                    -10.686
                                                ],
                                                [
                                                    -8.449,
                                                    -0.627
                                                ],
                                                [
                                                    -8.909,
                                                    0.231
                                                ],
                                                [
                                                    -8.813,
                                                    1.2
                                                ],
                                                [
                                                    -8.196,
                                                    1.952
                                                ],
                                                [
                                                    -7.265,
                                                    2.235
                                                ],
                                                [
                                                    -2.792,
                                                    2.235
                                                ],
                                                [
                                                    -2.535,
                                                    2.298
                                                ],
                                                [
                                                    -2.336,
                                                    2.471
                                                ],
                                                [
                                                    -2.239,
                                                    2.717
                                                ],
                                                [
                                                    -2.265,
                                                    2.98
                                                ],
                                                [
                                                    -4.375,
                                                    8.941
                                                ],
                                                [
                                                    -4.377,
                                                    10.049
                                                ],
                                                [
                                                    -3.687,
                                                    10.917
                                                ],
                                                [
                                                    -2.607,
                                                    11.165
                                                ],
                                                [
                                                    -1.608,
                                                    10.685
                                                ],
                                                [
                                                    8.451,
                                                    0.626
                                                ],
                                                [
                                                    8.909,
                                                    -0.233
                                                ],
                                                [
                                                    8.813,
                                                    -1.201
                                                ],
                                                [
                                                    8.196,
                                                    -1.953
                                                ],
                                                [
                                                    7.265,
                                                    -2.235
                                                ],
                                                [
                                                    2.798,
                                                    -2.235
                                                ],
                                                [
                                                    2.54,
                                                    -2.298
                                                ],
                                                [
                                                    2.341,
                                                    -2.471
                                                ],
                                                [
                                                    2.243,
                                                    -2.718
                                                ],
                                                [
                                                    2.27,
                                                    -2.981
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "gf",
                                    "nm": "Gradient Fill 1",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            13.412
                                        ]
                                    },
                                    "g": {
                                        "p": 3,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                0.51372552,
                                                0.36078432,
                                                0.96078438,
                                                0.5,
                                                0.2941176635,
                                                0.6588235649999999,
                                                0.729411815,
                                                1,
                                                0.074509807,
                                                0.95686281,
                                                0.49803925
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            -13.412
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            36,
                                            32
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.5255,
                                            0.3804,
                                            0.9529
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            36,
                                            32
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.624,
                                                    3.625
                                                ],
                                                [
                                                    -3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.624,
                                                    3.625
                                                ],
                                                [
                                                    3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.813
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            526.5,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.673,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.673,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.083
                                                ],
                                                [
                                                    -12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.083
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.6863,
                                            0.5843,
                                            0.9961
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            526.5,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -278,
                                                    -7.5
                                                ],
                                                [
                                                    -254,
                                                    -31.5
                                                ],
                                                [
                                                    254,
                                                    -31.5
                                                ],
                                                [
                                                    278,
                                                    -7.5
                                                ],
                                                [
                                                    278,
                                                    31.5
                                                ],
                                                [
                                                    -278,
                                                    31.5
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            278,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        }
    ]
};

//# sourceMappingURL=enterprise-ai-chatbot.85bbc0de.js.map
